import './styles.scss'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { FacebookShareButton, WhatsappShareButton, FacebookIcon, EmailShareButton, EmailIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, TwitterIcon, TelegramShareButton, TelegramIcon } from 'react-share'
import { InputText } from 'primereact/inputtext'
import { useHistory, useLocation } from 'react-router-dom'
import { Tooltip } from 'primereact/tooltip'
import { getLocalLoggedInStatus, getLocalSingleDeviceId, getLocalTheme, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { useTranslation } from 'react-i18next'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { DragIcon, qriOS, qrPlayStore, WindowMinimizeIcon, WindowMaximizeIcon } from 'Assets/Icons'
import { Button } from 'primereact/button'
import SearchBar from 'Components/UIComponent/ExpandableSearch'
import { useResizeHandler } from 'Utils/commonMethods'
import { InputTextarea } from 'primereact/inputtextarea'
import { Skeleton } from 'primereact/skeleton'
import { supabase } from 'Services/supabaseClient'
import { MessageMenu } from 'Components/UIComponent/FloatingMenu'
import AttachmentMenu from 'Components/UIComponent/FloatingMenu/Attachment'
import AttachmentPreview from 'Components/UIComponent/AttachmentPreview'
import ComingSoonPopUp from 'Components/UIComponent/ComingSoonPopUp'
import ForwardMessageModal from './Components/ForwardMessageModal'

/* eslint-disable prefer-arrow-callback */

// --- Utilities  ---
export function UtcToLocalTimeFn(utcString, use12h) {
  const date = new Date(utcString)
  const options = { hour: '2-digit', minute: '2-digit', hour12: use12h }

  return date.toLocaleTimeString('en-US', options)
}

export const ChatMessage = React.memo(
  function ChatMessage({ msg, isOutgoing, formatTime, onAttachmentClick, menuNode, onReplyClick, activeCommunity, userRoleInCommunity }) {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    const [captionExpanded, setCaptionExpanded] = useState(false)
    const MAX_PREVIEW_CHARS = 240

    const rawText = (msg?.content || '').toString()
    const isLongText = rawText?.trim().length > MAX_PREVIEW_CHARS
    const previewText = isLongText && !expanded ? `${rawText.slice(0, MAX_PREVIEW_CHARS)?.trim()}...` : rawText

    const ts = msg.timestamp || msg.createdTimestamp || msg.created_at || null
    const userDetails = getLocalUserDetails()
    const contentWithLinks = (previewText || '')?.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')

    const hasTextContent = Boolean(msg?.content?.trim())
    const hasAttachments = Array.isArray(msg.attachments) && msg.attachments.length > 0
    const hasMediaAttachments = hasAttachments && msg.attachments.some((att) => att.mime_type?.startsWith('image/') || att.mime_type?.startsWith('video/'))
    const hasAnyCaption = hasAttachments && msg.attachments.some((att) => att.caption && att.caption.trim())
    const hasOnlyMediaAttachments = hasMediaAttachments && msg.attachments.every((att) => att.mime_type?.startsWith('image/') || att.mime_type?.startsWith('video/'))
    const shouldOverlayTimestamp = hasOnlyMediaAttachments && !hasTextContent && !hasAnyCaption

    const renderTimestamp = (extraClass = '') => {
      const approvalStatus = msg?.approved_status
      const hasUrl = msg?.has_url
      // Only show approval status for outgoing messages (messages sent by current user)
      const showApprovalStatus = isOutgoing && hasUrl && approvalStatus

      const getApprovalStatusLabel = () => {
        if (approvalStatus === 'PENDING') return 'Pending'
        // if (approvalStatus === 'APPROVED') return 'Approved'
        // if (approvalStatus === 'REJECTED') return 'Rejected'

        return ''
      }

      return (
        <span className={`time ${extraClass}`.trim()}>
          {showApprovalStatus && <span className="approval-status-label">&nbsp; {getApprovalStatusLabel()}</span>}
          {msg.edited_at && <span className="edited-label">Edited&nbsp;</span>}
          {ts ? formatTime(ts) : ''}
        </span>
      )
    }

    const abuseFlagCount = msg?.abuse_flag_count || 0

    const showIconBasedOnAttachmentType = (type, attachments) => {
      const count = attachments?.length || 0

      if (type === 'image') {
        return (
          <div>
            <i className="pi pi-camera"></i>
            <p>Photo{count > 1 ? ` (+${count - 1})` : ''}</p>
          </div>
        )
      }

      if (type === 'document') {
        return (
          <div>
            <i className="pi pi-file-pdf"></i>
            <p>Document{count > 1 ? ` (+${count - 1})` : ''}</p>
          </div>
        )
      }

      if (type === 'video') {
        return (
          <div>
            <i className="pi pi-video"></i>
            <p>Video{count > 1 ? ` (+${count - 1})` : ''}</p>
          </div>
        )
      }

      return null
    }

    return (
      <div className="bubble">
        {/* {msg?.reply_to_id && (msg?.repliedMessage || msg?.is_reply_deleted) && ( */}
        {msg?.reply_to_id && (
          <div
            className={`replied-message-preview ${isOutgoing ? 'out' : 'in'}`}
            onClick={(e) => {
              e.stopPropagation()
              if (onReplyClick && msg?.reply_to_id) {
                onReplyClick(msg.reply_to_id)
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <div className="user-details">
              {msg?.repliedMessage?.user?.userid === userDetails?.id ? (
                'You'
              ) : (
                <>
                  {msg?.repliedMessage?.user?.first_name?.trim() || msg?.repliedMessage?.user_info?.first_name?.trim()} {msg?.repliedMessage?.user?.last_name?.trim() || msg?.repliedMessage?.user_info?.last_name?.trim()}
                </>
              )}
            </div>
            {/*  eslint-disable-next-line */}
            <div className="replied-message-text">{msg?.is_reply_deleted ? 'Message deleted' : msg?.repliedMessage?.attachmentsType ? showIconBasedOnAttachmentType(msg?.repliedMessage?.attachmentsType, msg?.repliedMessage?.attachmentsCount) : msg?.repliedMessage?.content || ''}</div>
          </div>
        )}
        {abuseFlagCount > 0 && (
          <div className={`abuse-flag-indicator ${isOutgoing ? 'out' : 'in'}`}>
            <i className="pi pi-flag-fill" />
            <span>{abuseFlagCount}</span>
          </div>
        )}
        <div>
          {msg?.is_forwarded && (
            <div className="forwarded-label">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className="forwarded-icon">
                <path d="m654-300-51-51 159-159-159-159 51-51 210 210-210 210Zm-510 90v-144q0-80 56-136t136-56h198L411-669l51-51 210 210-210 210-51-51 123-123H336q-50 0-85 35t-35 85v144h-72Z" />
              </svg>
              <span className="forwarded-text">{t('FORWARDED')}</span>
            </div>
          )}
          {!isOutgoing && (
            <div className="user-data">
              <img src={msg?.user_info?.users_flag_url} alt="Flag" loading="lazy" decoding="async" draggable={false} />
              <div className="user-details">
                {msg?.user_info?.first_name?.trim()} {msg?.user_info?.last_name?.trim()}
              </div>
              {menuNode && userDetails?.id && !(activeCommunity?.admin_only_message && userRoleInCommunity !== 'ADMIN') && <div className="inline-message-options">{menuNode}</div>}
            </div>
          )}

          {hasTextContent && (
            <div className={`text ${isOutgoing ? 'out' : 'in'} ${isLongText && !expanded ? 'clamped' : ''}`}>
              <div className={`message-content ${expanded ? 'show-less' : ''}`} dangerouslySetInnerHTML={{ __html: contentWithLinks || '' }} />
              {isLongText && (
                <div className={'read-more-btn'} onClick={() => setExpanded((prevExpanded) => !prevExpanded)}>
                  {expanded ? t('SHOW_LESS') : t('READ_MORE')}
                </div>
              )}
            </div>
          )}

          {hasAttachments &&
            (() => {
              // Separate media and documents
              const mediaAttachments = msg.attachments.filter((att) => att.mime_type?.startsWith('image/') || att.mime_type?.startsWith('video/'))
              const docAttachments = msg.attachments.filter((att) => !att.mime_type?.startsWith('image/') && !att.mime_type?.startsWith('video/'))
              const mediaCount = mediaAttachments.length
              const showMediaGrid = mediaCount > 0

              return (
                <div className={`attachments ${shouldOverlayTimestamp ? 'media-only' : ''}`}>
                  {/* Media Grid Layout - WhatsApp Style */}
                  {showMediaGrid && (
                    <div className={`media-grid media-grid-${Math.min(mediaCount, 5)}`}>
                      {mediaAttachments.slice(0, 4).map((att, idx) => {
                        const originalIdx = msg.attachments.indexOf(att)
                        const isMedia = att.mime_type?.startsWith('image/') || att.mime_type?.startsWith('video/')
                        const showOverlay = shouldOverlayTimestamp && isMedia && originalIdx === msg.attachments.length - 1
                        const isLastInGrid = idx === 3 && mediaCount > 4
                        const remainingCount = mediaCount - 4

                        const renderAttachment = () => {
                          const isPending = att.pending || msg.pending

                          if (att.mime_type?.startsWith('image/')) {
                            return (
                              <div className="attachment-media-container">
                                <img src={att.media_url} alt={att.file_name} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} draggable={false} loading="eager" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                {isPending && (
                                  <div className="attachment-upload-spinner">
                                    <i className="pi pi-spin pi-spinner" />
                                  </div>
                                )}
                              </div>
                            )
                          }

                          if (att.mime_type?.startsWith('video/')) {
                            return (
                              <div className="video-wrapper">
                                <video src={att.media_url} className="attachment-media" onClick={() => !isPending && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()} controlsList="nodownload" style={{ opacity: isPending ? 0.7 : 1, transition: 'opacity 0.2s ease-in-out' }} />
                                {isPending && (
                                  <div className="attachment-upload-spinner">
                                    <i className="pi pi-spin pi-spinner" />
                                  </div>
                                )}
                                {!isPending && (
                                  <div className="play-pause-btn" onClick={() => onAttachmentClick && onAttachmentClick(msg, att, originalIdx)}>
                                    <span className="pause-icon">▶</span>
                                  </div>
                                )}
                              </div>
                            )
                          }

                          return null
                        }

                        return (
                          <div
                            key={originalIdx}
                            className={`media-grid-item ${showOverlay ? 'has-overlay' : ''} ${isLastInGrid ? 'has-remaining' : ''}`}
                            onClick={() => {
                              if (isLastInGrid && onAttachmentClick && !(att.pending || msg.pending)) {
                                onAttachmentClick(msg, mediaAttachments[4], msg.attachments.indexOf(mediaAttachments[4]))
                              }
                            }}
                          >
                            <div className="attachment-media-wrapper">
                              {renderAttachment()}
                              {isLastInGrid && <div className="remaining-count-overlay">+{remainingCount}</div>}
                              {showOverlay && !isLastInGrid && renderTimestamp('overlay')}
                            </div>
                          </div>
                        )
                      })}
                      {/* Single media caption with Show More / Less */}
                      {mediaCount === 1 &&
                        mediaAttachments[0]?.caption &&
                        (() => {
                          const att = mediaAttachments[0]
                          const isLongCaption = att.caption.length > MAX_PREVIEW_CHARS
                          const previewCaption = isLongCaption && !captionExpanded ? `${att.caption.slice(0, MAX_PREVIEW_CHARS).trim()}...` : att.caption

                          return (
                            <div className="attachment-caption">
                              <span className={`message-content ${captionExpanded ? 'show-less' : ''}`}>{previewCaption}</span>

                              {isLongCaption && (
                                <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                  {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                                </div>
                              )}
                            </div>
                          )
                        })()}
                    </div>
                  )}

                  {/* Document attachments (non-media) */}
                  {docAttachments.map((att, idx) => {
                    const originalIdx = msg.attachments.indexOf(att)
                    const isLongCaption = att.caption && att.caption.length > MAX_PREVIEW_CHARS
                    const previewCaption = isLongCaption && !captionExpanded ? `${att.caption.slice(0, MAX_PREVIEW_CHARS).trim()}...` : att.caption

                    return (
                      <div key={`doc-${originalIdx}`} className="attachment-item">
                        <div className="attachment-doc" onClick={() => !(att.pending || msg.pending) && onAttachmentClick && onAttachmentClick(msg, att, originalIdx)} onContextMenu={(e) => e.preventDefault()}>
                          <i className="pi pi-file" />
                          <span>{att.file_name}</span>
                          {(att.pending || msg.pending) && (
                            <div className="attachment-upload-spinner">
                              <i className="pi pi-spin pi-spinner" />
                            </div>
                          )}
                        </div>
                        {att.caption && (
                          <div className="attachment-caption">
                            <span className={`message-content ${captionExpanded ? 'show-less' : ''}`}>{previewCaption}</span>
                            {isLongCaption && (
                              <div className="read-more-btn" onClick={() => setCaptionExpanded((prev) => !prev)}>
                                {captionExpanded ? t('SHOW_LESS') : t('READ_MORE')}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )
            })()}

          {/* Timestamp placement */}
          {hasAttachments && !shouldOverlayTimestamp && renderTimestamp(hasTextContent ? 'caption' : '')}
          {!hasAttachments && hasTextContent && renderTimestamp()}
        </div>
      </div>
    )
  },
  (prev, next) => prev.isOutgoing === next.isOutgoing && prev.msg.id === next.msg.id && prev.msg.content === next.msg.content && prev.msg.timestamp === next.msg.timestamp && prev.msg?.user?.users_flag_url === next.msg?.user?.users_flag_url && prev.msg?.user?.first_name === next.msg?.user?.first_name && prev.msg?.user?.last_name === next.msg?.user?.last_name && prev.msg?.edited_at === next.msg?.edited_at && prev.msg?.reply_to_id === next.msg?.reply_to_id && prev.msg?.repliedMessage === next.msg?.repliedMessage && prev.msg?.abuse_flag_count === next.msg?.abuse_flag_count && prev.onAttachmentClick === next.onAttachmentClick && prev.onReplyClick === next.onReplyClick && prev.activeCommunity?.id === next.activeCommunity?.id && prev.activeCommunity?.admin_only_message === next.activeCommunity?.admin_only_message && prev.userRoleInCommunity === next.userRoleInCommunity
)

const handleReply = (msg, setRepliedMessage, repliedMsgRef, inputRef) => {
  setRepliedMessage(msg)

  if (inputRef.current) {
    inputRef.current.focus()
  }

  if (repliedMsgRef) {
    const ref = repliedMsgRef

    ref.current = msg
  }
}

// --- CommunityRow (TOP-LEVEL) ---
export const CommunityRow = React.memo(
  function CommunityRow({ groupData, index, activeId, onDragStart, onDrop, onClick, draggable }) {
    const isCreateOwn = groupData?.isCreateOwn

    const renderCommunityAvatar = () => {
      if (isCreateOwn) {
        return <i className="pi pi-plus-circle create-own-icon" aria-hidden="true" />
      }

      if (groupData?.isUrlApproval) {
        return <i className="pi pi-shield url-approval-icon" aria-hidden="true" />
      }

      if (groupData?.community_url) {
        return <img alt="community-logo" src={groupData.community_url} loading="lazy" decoding="async" draggable={false} />
      }

      return <div className="avatar-text">{groupData?.name?.[0]}</div>
    }

    return (
      <div className={`community-item ${groupData.id === activeId ? 'active' : ''}`} draggable={draggable && !isCreateOwn} onDragStart={!isCreateOwn ? (e) => onDragStart(e, index) : undefined} onDragOver={!isCreateOwn ? (e) => e.preventDefault() : undefined} onDrop={!isCreateOwn ? (e) => onDrop(e, index) : undefined} onClick={() => onClick(groupData)}>
        <div className={`community-name ${groupData.id === activeId ? 'active' : ''}`}>
          {renderCommunityAvatar()}
          {/* <img alt="community-logo" src={groupData.community_url || 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'} loading="lazy" decoding="async" draggable={false} /> */}
          <span>{groupData.name}</span>
        </div>
        <div className="unread-subscription-info-container">
          <div className={`unread-count-div ${groupData.id === activeId ? 'active' : ''} ${groupData.unread_count > 0 && groupData.unread_count <= 99 ? '' : 'active'}`}>{groupData.unread_count > 0 && groupData.unread_count <= 99 ? groupData.unread_count : '99+'}</div>
          {!isCreateOwn && (
            <div>
              <DragIcon data-testid="drag-icon" />
            </div>
          )}
        </div>
      </div>
    )
  },
  (prev, next) =>
    // Ignore handler identity; compare only meaningful data
    prev.activeId === next.activeId && prev.index === next.index && prev.groupData.id === next.groupData.id && prev.groupData.name === next.groupData.name && prev.groupData.community_url === next.groupData.community_url && prev.groupData.unread_count === next.groupData.unread_count && prev.groupData.isUrlApproval === next.groupData.isUrlApproval
)

const CoffeeCommunities = ({ componentLabel }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { setLoading } = useContext(CoffeeWebContext)
  const repliedMsgRef = useRef(null)
  const PAGE_SIZE = 20
  const uploaderRef = useRef()
  const [theme, setTheme] = useState(getLocalTheme() || 'light')

  const { isWebView } = useResizeHandler()
  const userDetails = getLocalUserDetails()
  const userLoginStatus = getLocalLoggedInStatus()

  const inputRef = useRef(null)
  const containerRef = useRef(null)
  const earliestTimestampRef = useRef(null) // min timestamp we currently have
  const existingIdsRef = useRef(new Set()) // set of ids we already added
  const isInitialLoadRef = useRef(true)
  const isFetchingRef = useRef(false)
  const hasMoreRef = useRef(true)
  const nextCursorRef = useRef(null)
  const editInputRef = useRef(null)
  const previewRef = useRef(null)

  useEffect(() => {
    const updateTheme = () => {
      const theme = getLocalTheme()

      setTheme(theme)
    }

    window.addEventListener('themeChanged', updateTheme)

    return () => {
      window.removeEventListener('themeChanged', updateTheme)
    }
  }, [])

  const updateCommunitySearchParam = React.useCallback(
    (communityId) => {
      const params = new URLSearchParams(location.search)

      if (communityId) {
        params.set('communityId', String(communityId))
      } else {
        params.delete('communityId')
      }

      const searchString = params.toString()

      history.replace({
        pathname: location.pathname,
        search: searchString ? `?${searchString}` : ''
      })
    },
    [history, location.pathname, location.search]
  )

  // const [showReadMore, setShowReadMore] = useState(false) /  Commented for Read More and Show Less Functionality
  const [expanded, setExpanded] = useState(false)
  const [activeId, setActiveId] = useState('')
  const [chats, setChats] = useState([])
  const [value, setValue] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [activeSocialMediaLists, setActiveSocialMediaLists] = useState('')
  const [shortenUrl, setShortenUrl] = useState('')
  const [isCopied, setIsCopied] = useState(false)
  const [searchCommunityTerm, setSearchCommunityTerm] = useState('')
  const [groupList, setGroupList] = useState([])
  const [activeCommunity, setActiveCommunity] = useState('')

  const [isCommunitiesLoading, setIsCommunitiesLoading] = useState(true)
  const [createCommunityInstructions, setCreateCommunityInstructions] = useState([])
  const [isChatLoading, setIsChatLoading] = useState(false)
  // const [nextCursor, setNextCursor] = useState(null) // Commented if chat scroll through cursor
  const [isFetchingOlder, setIsFetchingOlder] = useState(false)
  const [filteredGroupList, setFilteredGroupList] = useState(groupList)
  const [repliedMessage, setRepliedMessage] = useState(null)
  const [isChatScrollable, setIsChatScrollable] = useState(false)
  const [showRedirectText, setShowRedirectText] = useState(false)
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [modalAction, setModalAction] = useState(null) // 'deleteForMe' | 'deleteForEveryone' | 'edit'
  const [modalMessage, setModalMessage] = useState(null)
  const [editValue, setEditValue] = useState('')
  const [isAdminUser, setIsAdminUser] = useState(false)
  const [isBlocked, setIsBlocked] = useState(false)
  const [showBlockedModal, setShowBlockedModal] = useState(false)
  const [userRoleInCommunity, setUserRoleInCommunity] = useState(null)
  const [reportReasons, setReportReasons] = useState([])
  const [selectedReportReason, setSelectedReportReason] = useState(null)
  const [isReporting, setIsReporting] = useState(false)
  const [unreadCount, setUnreadCount] = useState(0)
  const [attachments, setAttachments] = useState([]) // array of { file, previewUrl, type: 'media'|'doc', name, size }
  const [isUploadingImage, setIsUploadingImage] = useState(false)
  // URL approval state
  const [pendingUrlMessages, setPendingUrlMessages] = useState([])
  const [pendingUrlsError, setPendingUrlsError] = useState(null)
  const [isUrlActionLoading, setIsUrlActionLoading] = useState(false)
  const [copiedUrlId, setCopiedUrlId] = useState(null)

  // Forward message state
  const [forwardModalVisible, setForwardModalVisible] = useState(false)
  const [messageToForward, setMessageToForward] = useState(null)
  const [isForwarding, setIsForwarding] = useState(false)
  const [forwardSearchTerm, setForwardSearchTerm] = useState('')
  const [selectedCommunitiesForForward, setSelectedCommunitiesForForward] = useState([])

  const MAX_FILE_SIZE = 30 * 1024 * 1024 // 30 MB (matches Supabase bucket limit)
  // const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50 MB
  const MAX_FILES = 100

  // URL detection function
  const detectUrls = (text) => {
    if (!text || typeof text !== 'string') return false
    const urlRegex = /https?:\/\/[^\s]+/g

    return urlRegex.test(text)
  }

  // Extract all URLs from text
  const extractUrls = (text) => {
    if (!text || typeof text !== 'string') return []
    // Match URLs with protocol (http://, https://), starting with www., or domain patterns
    // Pattern: protocol URLs, www. URLs, or domain.tld patterns
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.[a-zA-Z]{2,}[^\s]*)/gi
    const matches = text.match(urlRegex) || []

    return matches
      .map((url) => {
        // Remove trailing punctuation
        const cleanedUrl = url.replace(/[.,;:!?]+$/, '')
        // Add protocol if missing

        if (!cleanedUrl.startsWith('http://') && !cleanedUrl.startsWith('https://')) {
          return `https://${cleanedUrl}`
        }

        return cleanedUrl
      })
      .filter((url) => {
        // Filter out very short matches and ensure it looks like a URL
        const cleanUrl = url.replace(/^https?:\/\//, '')

        return cleanUrl.length > 3 && cleanUrl.includes('.')
      })
  }

  // Check if message or attachments contain URLs
  const hasUrlInMessage = (content, attachments) => {
    // Check message content
    if (detectUrls(content)) return true

    // Check attachment captions
    if (Array.isArray(attachments) && attachments.length > 0) {
      return attachments.some((att) => detectUrls(att.caption || ''))
    }

    return false
  }

  const addFiles = (fileList, kind) => {
    if (!fileList || !fileList.length) return

    const incoming = fileList.map((f, i) => ({
      file: f,
      name: f.name,
      size: f.size,
      mime: f.type,
      kind, // 'media' or 'doc'
      previewUrl: kind === 'media' ? URL.createObjectURL(f) : null,
      id: `att-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      caption: i === 0 ? value?.trim() || '' : '',
      sourceMessage: i === 0 ? Boolean(value?.trim()) : false
    }))

    const errors = []
    const allowedNow = MAX_FILES - attachments.length

    if (incoming.length > allowedNow) {
      errors.push(`You can attach up to ${MAX_FILES} files. You can add ${allowedNow} more.`)
    }

    const validated = []

    for (let i = 0; i < Math.min(incoming.length, allowedNow); i++) {
      const it = incoming[i]

      let valid = true

      if (it.size > MAX_FILE_SIZE) {
        errors.push(`${it.name} exceeds maximum size of 50MB`)
        valid = false
      }

      if (valid && kind === 'media') {
        const ok = /(image\/jpeg|image\/png|video\/mp4|video\/quicktime)/.test(it.mime)

        if (!ok) {
          errors.push(`${it.name} is not a supported media file`)
          valid = false
        }
      } else if (valid) {
        const ok = /\.(pdf|docx|doc|xls|xlsx|csv|txt)$/i.test(it.name)

        if (!ok) {
          errors.push(`${it.name} is not a supported document type`)
          valid = false
        }
      }

      if (valid) validated.push(it)
    }

    if (errors.length) {
      // you can surface these through UI; for now use console and a user-facing alert
      // minimal UI feedback
      alert(errors.join('\n'))
    }

    // if (validated.length) {
    //   setAttachments((prev) => [...prev, ...validated])
    // }

    return validated // Return the validated attachments instead of setting state
  }

  const [viewer, setViewer] = useState({
    open: false,
    type: null,
    url: '',
    name: '',
    attachments: [], // All attachments in the message
    currentIndex: 0 // Current attachment being viewed
  })

  const [isFullscreen, setIsFullscreen] = useState(false)

  const openViewer = (msg, att, index) => {
    setViewer({
      open: true,
      type: att.mime_type,
      url: att.media_url,
      name: `${userDetails?.id === msg?.user_info?.userid ? 'You' : `${msg?.user_info?.first_name} ${msg?.user_info?.last_name}`} `,
      attachments: msg.attachments || [],
      currentIndex: index
    })
  }

  const closeViewer = () => {
    setViewer({
      open: false,
      type: null,
      url: '',
      name: '',
      attachments: [],
      currentIndex: 0
    })
    setIsFullscreen(false) // Reset fullscreen when closing
  }

  // Add navigation functions
  const navigateAttachment = (direction) => {
    const { attachments, currentIndex } = viewer

    if (!attachments || attachments.length === 0) return

    let newIndex

    if (direction === 'prev') {
      newIndex = currentIndex > 0 ? currentIndex - 1 : attachments.length - 1
    } else {
      newIndex = currentIndex < attachments.length - 1 ? currentIndex + 1 : 0
    }

    const newAtt = attachments[newIndex]

    setViewer({
      ...viewer,
      url: newAtt.media_url,
      type: newAtt.mime_type,
      currentIndex: newIndex
    })
  }

  // Add keyboard navigation
  useEffect(() => {
    if (!viewer.open) return

    const handleKeyPress = (e) => {
      if (e.key === 'ArrowLeft') {
        navigateAttachment('prev')
      } else if (e.key === 'ArrowRight') {
        navigateAttachment('next')
      } else if (e.key === 'Escape') {
        closeViewer()
      }
    }

    window.addEventListener('keydown', handleKeyPress)

    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [viewer.open, viewer.currentIndex])

  const viewerModalContent = () => {
    if (!viewer.url) return null

    const isImage = viewer.type?.startsWith('image/')
    const isVideo = viewer.type?.startsWith('video/')
    const isPdf = viewer.type === 'application/pdf' || viewer.name?.toLowerCase().endsWith('.pdf')
    const isDoc = viewer.type?.includes('document') || /\.(docx|doc|xls|xlsx|csv|txt)$/i.test(viewer.name)
    const hasMultipleImages = viewer.attachments && viewer.attachments.length > 1

    // Only show navigation for images
    const showNavigation = hasMultipleImages

    return (
      <div className={`attachment-viewer-content ${isFullscreen ? 'fullscreen' : ''}`}>
        <div className="attachment-viewer-wrapper">
          {isImage && <img src={viewer.url} alt={viewer.name} style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} onContextMenu={(e) => e.preventDefault()} draggable={false} />}
          {isVideo && <video src={viewer.url} controls autoPlay={true} style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} controlsList="nodownload noplaybackrate" disablePictureInPicture onContextMenu={(e) => e.preventDefault()} />}
          {isPdf && <iframe src={viewer.url} title={viewer.name} style={{ width: '100%', height: '100%', border: 'none' }} onContextMenu={(e) => e.preventDefault()} />}
          {isDoc && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '20px' }}>
              <i className="pi pi-file" style={{ fontSize: '64px', color: '#666', marginBottom: '16px' }} />
              <p style={{ margin: 0, color: '#666' }}>Document preview not available</p>
              <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#999' }}>{viewer.name}</p>
            </div>
          )}
        </div>
        {viewer.attachments.length > 0 && <div className="attachment-viewer-caption">{viewer.attachments[viewer.currentIndex]?.caption}</div>}
        {/* Navigation Arrows */}
        {showNavigation && (
          <>
            <button className="nav-arrow nav-arrow-left" onClick={() => navigateAttachment('prev')} aria-label="Previous image">
              <i className="pi pi-chevron-left" />
            </button>
            <button className="nav-arrow nav-arrow-right" onClick={() => navigateAttachment('next')} aria-label="Next image">
              <i className="pi pi-chevron-right" />
            </button>
            <div className="image-counter">
              {viewer.currentIndex + 1} / {viewer.attachments.length}
            </div>
          </>
        )}
      </div>
    )
  }

  const handleMediaSelected = (files) => {
    const newAttachments = addFiles(files, 'media')

    if (newAttachments?.length) {
      setAttachments((prev) => [...prev, ...newAttachments])
      setValue('')
    }
  }

  const handleDocumentSelected = (files) => {
    const newAttachments = addFiles(files, 'doc')

    if (newAttachments?.length) {
      setAttachments((prev) => [...prev, ...newAttachments])
      setValue('')
    }
  }

  const removeAttachment = (attId) => {
    setAttachments((prev) => {
      const found = prev.find((p) => p.id === attId)

      if (found && found.previewUrl) URL.revokeObjectURL(found.previewUrl)

      return prev.filter((p) => p.id !== attId)
    })
  }

  const openConfirmationModal = (action, msg) => {
    if (!userDetails?.id) {
      setShowRedirectText(true)

      return
    }

    setModalAction(action)
    setModalMessage(msg)
    setConfirmationModal(true)
    if (action === 'edit') setEditValue(msg.content)
  }

  const handleModalConfirm = async () => {
    if (modalAction === 'deleteForMe') {
      await handleDeleteForMe(modalMessage)
    } else if (modalAction === 'deleteForEveryone') {
      await handleDeleteForEveryone(modalMessage)
    } else if (modalAction === 'edit' && editValue) {
      // Check if edited message contains URLs (in content or attachment captions)
      const messageAttachments = modalMessage.attachments || []
      const messageHasUrl = hasUrlInMessage(editValue, messageAttachments)

      // Prepare update payload
      const updatePayload = {
        content: editValue,
        edited_at: new Date().toISOString()
      }

      // Update has_url and approved_status based on URL detection
      if (messageHasUrl) {
        updatePayload.has_url = true
        updatePayload.approved_status = 'PENDING'
      } else if (modalMessage.has_url) {
        // If message previously had URL but now doesn't, clear the URL flags
        updatePayload.has_url = false
        updatePayload.approved_status = null
      }

      await supabase.from('messages').update(updatePayload).eq('id', modalMessage.id)

      // Update local state with all changes
      setChats((prev) => prev.map((msg) => (msg.id === modalMessage.id ? { ...msg, ...updatePayload } : msg)))
    } else if (modalAction === 'deleteMessageByAdmin') {
      await handleDeleteMessageByAdmin(modalMessage)
    } else if (modalAction === 'deleteAllMessageByAdmin') {
      await handleDeleteAllMessageByAdmin(modalMessage)
    } else if (modalAction === 'blockUserByAdmin') {
      await handleBlockUserByAdmin(modalMessage)
    } else if (modalAction === 'reportAbuse') {
      await handleReportAbuse(modalMessage)
    }
    setConfirmationModal(false)
    setModalAction(null)
    setModalMessage(null)
    setEditValue('')
  }

  const confirmationModalContent = () => {
    if (!modalMessage) return null

    if (modalAction === 'edit') {
      return (
        <div className="edit-modal-content">
          <div
            className={`message-preview${expanded ? ' expanded' : ''}`}
            ref={previewRef}
            // Commented for Read More and Show Less Functionality

            // style={
            //   expanded
            //     ? {
            //         maxHeight: '180px',
            //         overflowY: 'auto',
            //         whiteSpace: 'pre-line',
            //         wordBreak: 'break-word'
            //       }
            //     : {
            //         display: '-webkit-box',
            //         WebkitLineClamp: 5,
            //         WebkitBoxOrient: 'vertical',
            //         overflow: 'hidden',
            //         whiteSpace: 'pre-line',
            //         wordBreak: 'break-word'
            //       }
            // }
          >
            <div>{modalMessage.content}</div>
            <div className="time">{formatTime(modalMessage.timestamp)}</div>
          </div>
          {/* Commented for Read More and Show Less Functionality */}
          {/* {!expanded && showReadMore && (
            <div className="read-more-row">
              <span
                style={{
                  color: '#ae5e49',
                  cursor: 'pointer',
                  fontWeight: 600,
                  marginLeft: 'auto',
                  display: 'inline-block'
                }}
                onClick={() => setExpanded(true)}
              >
                Read more
              </span>
            </div>
          )}
          {expanded && (
            <span style={{ color: '#ae5e49', cursor: 'pointer', float: 'right', marginLeft: '8px', fontWeight: 600 }} onClick={() => setExpanded(false)}>
              {' '}
              Show less
            </span>
          )} */}
        </div>
      )
    }
    if (modalAction === 'reportAbuse') {
      return (
        <div className="edit-modal-content">
          <div className="reported-message-box">
            <h5>Reported message:</h5>
            <span className="reported-content">{modalMessage.content}</span>
          </div>{' '}
          <br />
          <div style={{ marginBottom: 16, fontSize: 15 }}>Please select a reason for reporting this message:</div>
          <form>
            {reportReasons.length === 0 ? (
              <div>Loading reasons...</div>
            ) : (
              reportReasons.map((reason) => (
                <label key={reason.id} style={{ display: 'block', margin: '8px 0', cursor: 'pointer' }}>
                  <input type="radio" name="reportReason" value={reason.id} checked={selectedReportReason === reason.id} onChange={() => setSelectedReportReason(reason.id)} style={{ marginRight: 8 }} />
                  {reason?.display_name}
                </label>
              ))
            )}
          </form>
        </div>
      )
    }

    let confirmationHeading = 'Do you wish to proceed with this action?'
    let confirmationText = ''

    if (modalAction === 'deleteForMe') {
      confirmationHeading = 'Delete message for me'
      confirmationText = 'Do you wish to delete this message for yourself? This action cannot be undone.'
    } else if (modalAction === 'deleteForEveryone') {
      confirmationHeading = 'Delete message for everyone?'
      confirmationText = 'Do you wish to delete this message for everyone in this community? This action cannot be undone.'
    } else if (modalAction === 'deleteMessageByAdmin') {
      confirmationHeading = "Delete User's Message" // eslint-disable-line quotes
      confirmationText = 'Do you wish to delete the message of this User in this community? This action cannot be undone.'
    } else if (modalAction === 'deleteAllMessageByAdmin') {
      confirmationHeading = "Delete User's Message" // eslint-disable-line quotes
      confirmationText = 'Do you wish to delete all the message of this User in this community? This action cannot be undone.'
    } else if (modalAction === 'blockUserByAdmin') {
      confirmationHeading = 'Block User' // eslint-disable-line quotes
      confirmationText = 'Do you wish to Block this User in this community? This action cannot be undone.'
    }

    return (
      <div>
        {/* <div className="confirmation-modal-content">{confirmationHeading}</div> */}
        <div className="message-preview">{confirmationText}</div>
        {/* commented for message preview */}
        {/* <div className="message-preview">{modalMessage.content}</div> */}
      </div>
    )
  }

  const handleEditChange = (newValue) => {
    setEditValue(newValue)

    if (editInputRef.current) {
      const textarea = editInputRef.current

      textarea.style.height = 'auto'
      const CAP = 120

      const newHeight = Math.min(textarea.scrollHeight, CAP)

      textarea.style.height = `${newHeight}px`
      textarea.style.overflowY = textarea.scrollHeight > CAP ? 'auto' : 'hidden'
    }
  }

  const footerContent = () => {
    if (modalAction === 'edit') {
      return (
        <div className="input-area">
          <div className="edit-container">
            <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="coffee-web-logo" className="input-logo" />

            <InputTextarea
              ref={(el) => {
                const input = el

                editInputRef.current = input

                if (input) {
                  input.style.height = 'auto'
                  const CAP = 120
                  const newHeight = Math.min(input.scrollHeight, CAP)

                  input.style.height = `${newHeight}px`
                  input.style.overflowY = input.scrollHeight > CAP ? 'auto' : 'hidden'
                }
              }}
              rows={isWebView ? 1 : 2}
              cols={1}
              value={editValue}
              onKeyDown={(e) => handleEditKeyDown(e)}
              onChange={(e) => handleEditChange(e.target.value)}
              placeholder={`${placeholderText()}...`}
              className="edit-input-field"
            />
          </div>
          <Button rounded icon="pi pi-send send-icon" disabled={!editValue} className="send-button" onClick={handleModalConfirm} />
        </div>
      )
    }
    if (modalAction === 'reportAbuse') {
      return (
        <div className="confirmation-modal-buttons">
          <Button label="Cancel" className="confirmation-no-button" onClick={() => setConfirmationModal(false)} disabled={isReporting} />
          <Button
            label="Report"
            className="confirmation-yes-button"
            onClick={async () => {
              await handleReportAbuse(modalMessage)
              setConfirmationModal(false)
              setModalAction(null)
              setModalMessage(null)
              setSelectedReportReason(null)
            }}
            disabled={!selectedReportReason || isReporting}
          />
        </div>
      )
    }

    return (
      <div className="confirmation-modal-buttons">
        <Button label="No" className="confirmation-no-button" onClick={() => setConfirmationModal(false)} />
        <Button label="Yes" className="confirmation-yes-button" onClick={handleModalConfirm} />
      </div>
    )
  }

  // commented if chat scroll through cursor
  // useEffect(() => {
  //   nextCursorRef.current = nextCursor
  // }, [nextCursor])

  useEffect(() => {
    const container = containerRef.current

    if (!container) return

    const handleScroll = () => {
      if (container.scrollTop <= 60 && !isFetchingRef.current && hasMoreRef.current && activeCommunity?.id) {
        fetchOlderChats(activeCommunity.id)
      }
    }

    container.addEventListener('scroll', handleScroll)

    return () => container.removeEventListener('scroll', handleScroll)
  }, [activeCommunity?.id]) // rebind only when switching rooms

  // Fetch report reasons when reportAbuse modal opens
  useEffect(() => {
    if (confirmationModal && modalAction === 'reportAbuse') {
      setReportReasons([])
      setSelectedReportReason(null)
      supabase
        .rpc('get_report_reasons')
        .then((res) => {
          setReportReasons(res?.data?.reasons || [])
        })
        .catch(() => setReportReasons([]))
    }
  }, [confirmationModal, modalAction])

  useEffect(() => {
    if (!activeCommunity?.id || activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval) return
    isInitialLoadRef.current = true
    hasMoreRef.current = true
    nextCursorRef.current = null
    // setNextCursor(null) // Commented if chat scroll through cursor
    setChats([])
    setRepliedMessage(null)
    fetchOlderChats(activeCommunity.id)
  }, [activeCommunity?.id])

  const formatTime = React.useCallback(
    (ts) => {
      // This handles the case for Guest User and Logged-in User
      const use12h = userDetails?.id ? userDetails.userTimeFormat.startsWith('12') : false

      return UtcToLocalTimeFn(ts, use12h)
    },
    [userDetails?.id, userDetails?.userTimeFormat]
  )

  const fetchOlderChats = async (communityId) => {
    if (isFetchingRef.current) return
    if (activeCommunity?.isCreateOwn) return
    if (!communityId) return

    isFetchingRef.current = true
    setIsFetchingOlder(true)

    const container = containerRef.current
    const prevScrollHeight = container ? container.scrollHeight : 0
    const prevScrollTop = container ? container.scrollTop : 0

    try {
      const isInitialLoad = isInitialLoadRef.current || existingIdsRef.current.size === 0
      const offset = existingIdsRef.current.size

      const { data: attachmentMessages, error } = await supabase.rpc('get_community_messages_with_attachments', {
        p_community_id: communityId,
        p_user_id: userDetails?.id || 0,
        p_limit: PAGE_SIZE,
        p_offset: offset
      })

      if (error) {
        hasMoreRef.current = false

        return
      }

      // Filter out messages already in chat and deleted messages
      // Also filter based on approval status: pending URL messages only show to sender
      const newMessages = attachmentMessages?.messages?.filter((msg) => {
        if (existingIdsRef.current.has(String(msg.id))) return false
        if (msg.deleted_at !== null) return false
        if (msg.deleted_for_users && msg.deleted_for_users.includes(userDetails?.id)) return false

        // Filter based on approval status
        // If message has URL and is pending, only show to sender
        if (msg?.has_url && msg?.approved_status === 'PENDING') {
          return msg?.userid === userDetails?.id
        }

        return true
      })

      if (!newMessages?.length) {
        hasMoreRef.current = attachmentMessages?.messages?.length === PAGE_SIZE

        return
      }

      // Update refs
      newMessages.forEach((msg) => {
        existingIdsRef.current.add(String(msg.id))
      })

      // Sort chronologically
      const sortedMessages = newMessages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))

      // ========== ADD REPLY USER FETCHING LOGIC ==========

      // Get unique reply user IDs that need user info
      const replyUserIds = [
        ...new Set(
          sortedMessages
            .filter((m) => m.reply_to_id)
            .map((m) => m.reply_user_id)
            .filter(Boolean)
        )
      ]

      // Fetch reply user info in parallel
      const replyUsersMap = {}

      if (replyUserIds.length) {
        const replyUserFetches = await Promise.all(replyUserIds.map((userId) => supabase.from('users').select('userid, first_name, last_name, users_flag_url').eq('userid', userId).single()))

        replyUserFetches.forEach((r) => {
          if (r?.data) {
            replyUsersMap[r.data.userid] = r.data
          }
        })
      }

      // ========== BUILD MESSAGES WITH REPLIES AND ATTACHMENT CHECK ==========

      const messagesWithReplies = await Promise.all(
        sortedMessages.map(async (msg) => {
          let repliedMessage = null

          // Check if the replied message has an attachment (using reply_to_id)
          if (msg.reply_to_id) {
            const replyMessage = await supabase.from('messages').select('has_attachments').eq('id', msg.reply_to_id).single()
            // const attachmentType = await supabase.from('message_attachments').select('media_type').eq('message_id', msg.reply_to_id).single()

            const { data: attachments, error: attachmentError } = await supabase.from('message_attachments').select('media_type').eq('message_id', msg.reply_to_id)

            let hasAttachment = false
            let attachmentsCount = 0
            let firstAttachmentType = null

            if (attachments && attachments.length > 0) {
              hasAttachment = true
              attachmentsCount = attachments.length
              firstAttachmentType = attachments[0].media_type // first occurrence
            }

            if (replyMessage?.data?.has_attachments) {
              hasAttachment = true
            }

            if (msg.is_reply_deleted) {
              const replyUser = replyUsersMap[msg.reply_user_id]

              repliedMessage = {
                id: msg.reply_to_id,
                content: null, // This will trigger "Message deleted" in UI
                userid: msg.reply_user_id,
                user: replyUser || {
                  userid: msg.reply_user_id,
                  first_name: 'User',
                  last_name: '',
                  users_flag_url: ''
                },
                hasAttachment,
                attachmentsType: firstAttachmentType
              }
            } else {
              const replyUser = replyUsersMap[msg.reply_user_id]

              repliedMessage = {
                id: msg.reply_to_id,
                content: msg.is_reply_deleted ? null : msg.reply_content,
                userid: msg.reply_user_id,
                user: replyUser || {
                  userid: msg.reply_user_id,
                  first_name: 'User',
                  last_name: '',
                  users_flag_url: ''
                },
                hasAttachment,
                attachmentsCount,
                attachmentsType: firstAttachmentType
              }
            }
          }

          return {
            ...msg,
            repliedMessage
          }
        })
      )

      // ========== REST OF YOUR EXISTING LOGIC ==========

      if (isInitialLoad) {
        setChats((prevOptimistic) => {
          const optimistic = prevOptimistic.filter((p) => !p.id)

          return [...messagesWithReplies, ...optimistic]
        })
        isInitialLoadRef.current = false

        requestAnimationFrame(() => {
          if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight
          }
        })
      } else {
        setChats((prev) => [...messagesWithReplies, ...prev])

        requestAnimationFrame(() => {
          if (!containerRef.current) return
          const newScrollHeight = containerRef.current.scrollHeight
          const delta = newScrollHeight - prevScrollHeight

          containerRef.current.scrollTop = prevScrollTop + delta
        })
      }

      hasMoreRef.current = attachmentMessages?.messages?.length === PAGE_SIZE

      // Reset unread count when opening community
      if (activeCommunity?.unread_count > 0 || !('unread_count' in activeCommunity)) {
        await supabase
          .from('community_members')
          .update({
            unread_count: 0,
            last_read_timestamp: new Date().toISOString()
          })
          .eq('userid', userDetails?.id)
          .eq('community_id', communityId)
      }
    } catch (err) {
      console.error('[fetchOlderChats] unexpected error', err)
    } finally {
      isFetchingRef.current = false
      setIsFetchingOlder(false)
    }
  }

  const imgUrl = 'https://coffeeweb.s3.ap-south-1.amazonaws.com/coffeeweb_menu_icons/CoffeeWeb_Logo_White_Background_Blue_Text.png'
  const newsTitle = 'CoffeeWeb Community'
  const shareLinksFowWhatsApp = 'Link'
  const newsTitleForWhatsApp = 'Coffee Communities'

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    getAllGroupsList()
  }, [])

  const atBottomRef = useRef(true)
  const BOTTOM_EPS = 24

  const [showScrollButton, setShowScrollButton] = useState(false) // UI state

  useEffect(() => {
    const el = containerRef.current

    if (!el) return
    const onScroll = () => {
      const distance = el.scrollHeight - (el.scrollTop + el.clientHeight)

      const isAtBottom = distance < BOTTOM_EPS

      atBottomRef.current = isAtBottom
      setShowScrollButton(!isAtBottom)

      if (isAtBottom) setUnreadCount(0)
    }

    el.addEventListener('scroll', onScroll)
    // initialize once
    onScroll()

    return () => el.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const el = containerRef.current

    if (!el || !atBottomRef.current) return

    // wait for commit + layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
      })
    })
  }, [chats.length]) // only when a row is added/removed

  // ============ Fetch Real Time Data ============
  useEffect(() => {
    const channel = supabase
      .channel('communities:all')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'community_members',
          filter: `userid=eq.${userDetails?.id}`
        },

        handleRealTimeCommunities
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          // console.log('Realtime subscribed for Notifications')
        }
      })

    return () => {
      supabase.removeChannel(channel)
    }
  }, [])

  useEffect(() => {
    if (!activeCommunity?.id || activeCommunity?.isCreateOwn) return

    const channel = supabase
      .channel(`community:${activeCommunity.id}`)

      // INSERT
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `community_id=eq.${activeCommunity.id}`
        },
        async (payload) => {
          await handleRealtimeMessage(payload.new)
        }
      )

      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'messages',
          filter: `community_id=eq.${activeCommunity.id}`
        },
        async (payload) => {
          const updatedMessage = payload.new

          // Soft delete handling
          if (updatedMessage.deleted_at) {
            setChats((prev) => prev.filter((msg) => msg.id !== updatedMessage.id))

            return
          }

          // Handle approval status updates
          // If message was pending and is now approved, fetch full message data with attachments
          if (updatedMessage.has_url && updatedMessage.approved_status === 'APPROVED') {
            // Fetch the full message with attachments if it was just approved
            const { data: fullMessage } = await supabase.rpc('get_community_messages_with_attachments', {
              p_community_id: activeCommunity.id,
              p_user_id: userDetails?.id || 0,
              p_limit: 1,
              p_offset: 0
            })

            if (fullMessage?.messages?.[0] && fullMessage.messages[0].id === updatedMessage.id) {
              const approvedMsg = fullMessage.messages[0]

              // Check if message already exists in chats
              setChats((prev) => {
                const existingIndex = prev.findIndex((msg) => msg.id === approvedMsg.id)

                if (existingIndex >= 0) {
                  // Update existing message
                  const newChats = [...prev]

                  newChats[existingIndex] = { ...newChats[existingIndex], ...approvedMsg }

                  return newChats
                }

                // Add new approved message (now visible to all)
                return [...prev, approvedMsg]
              })

              return
            }

            // Fallback: just update the message
            setChats((prev) => prev.map((msg) => (msg.id === updatedMessage.id ? { ...msg, ...updatedMessage } : msg)))

            return
          }

          // Normal message update (e.g. edited content, approval status change to rejected)
          setChats((prev) => prev.map((msg) => (msg.id === updatedMessage.id ? { ...msg, ...updatedMessage } : msg)))
        }
      )

      // Listen for hard deletes (admin deletes from DB)
      .on(
        'postgres_changes',
        {
          event: 'DELETE',
          schema: 'public',
          table: 'messages',
          filter: `community_id=eq.${activeCommunity.id}`
        },
        (payload) => {
          const deletedId = payload.old?.id

          if (deletedId) {
            setChats((prev) => prev.filter((msg) => msg.id !== deletedId))
          }
        }
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          // console.log('Realtime subscribed for community', activeCommunity.name)
        }
      })

    setUnreadCount(0)

    return () => {
      supabase.removeChannel(channel)
    }
  }, [activeCommunity?.id])

  useEffect(() => {
    if (!userDetails?.id || !activeCommunity?.id || activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval) return

    checkBlockedStatus()
    checkUserRole()

    const channel = supabase
      .channel('communities:user-blocked-status')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'community_members',
          filter: `community_id=eq.${activeCommunity?.id}`
        },
        handleRealTimeBlockStatus
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          console.log('Realtime subscribed for Blocked Status')
        }
      })

    return () => {
      supabase.removeChannel(channel)
    }
  }, [activeCommunity?.id, userDetails?.id])

  function handleRealTimeCommunities(payload) {
    const communitiesData = payload.new

    setFilteredGroupList((prev) =>
      prev.map((item) =>
        String(item.id) === String(communitiesData.community_id)
          ? { ...item, unread_count: communitiesData.unread_count ?? 0 } // only update the matched one
          : item
      )
    )
  }

  // Realtime handler for new messages
  async function handleRealtimeMessage(message) {
    const userId = message.userid

    const { data: user, error } = await supabase.from('users').select('userid, first_name, last_name, users_flag_url').eq('userid', userId).single()

    // Fetch attachments - with retry logic if has_attachments is true
    let attachments = []

    if (message.has_attachments) {
      // Add a small delay to ensure attachments are written to DB
      await new Promise((resolve) => {
        setTimeout(resolve, 100)
      })

      const { data: attachmentsData, error: attError } = await supabase
        .from('message_attachments')
        .select('*')
        .eq('message_id', message.id)
        .eq('is_visible', true) // filter by visible attachments
        .order('sort_order', { ascending: true })
        .order('created_at', { ascending: true })

      if (!attError && attachmentsData) {
        attachments = attachmentsData
      } else {
        console.warn('Error fetching attachments:', attError)
      }
    }

    // Do not mutate the function parameter `message`; create a new object instead
    const msg = { ...message, attachments }

    if (error) {
      console.error('Error fetching user:', error)

      return
    }

    let replied = null

    if (msg.reply_to_id) {
      const { data: rep, error: repErr } = await supabase.from('messages').select('id, userid, content, has_attachments, timestamp, user:users!messages_userid_fkey(userid, first_name, last_name, users_flag_url)').eq('id', msg.reply_to_id).single()

      if (repErr || !rep) {
        console.warn('Replied message not found for id', msg.reply_to_id, repErr)
      } else {
        let attachmentsCount = 0
        let firstAttachmentType = null
        const hasAttachment = !!rep.has_attachments

        if (hasAttachment) {
          // small delay ensures DB consistency
          // eslint-disable-next-line
          await new Promise((resolve) => setTimeout(resolve, 100))

          const { data: attData, error: attErr } = await supabase.from('message_attachments').select('media_type').eq('message_id', rep.id)

          if (!attErr && attData && attData.length > 0) {
            attachmentsCount = attData.length
            firstAttachmentType = attData[0].media_type
          } else if (attErr) {
            console.warn('Error fetching replied message attachments:', attErr)
          }
        }

        // Build repliedMessage with attachment info
        replied = {
          ...rep,
          hasAttachment,
          attachmentsCount,
          attachmentsType: firstAttachmentType
        }
      }
    }

    const fullMessage = {
      ...msg,
      user_info: user,
      repliedMessage: replied // may be null
    }

    // Filter messages based on approval status
    // If message has URL and is pending, only show to sender
    const shouldShowMessage =
      fullMessage?.userid === userDetails?.id || // Always show sender's own messages
      !(fullMessage?.has_url && fullMessage?.approved_status === 'PENDING') // Show if not pending URL message

    if (shouldShowMessage) {
      // Check if message already exists (to avoid duplicates)
      setChats((prev) => {
        // First check if message with this ID already exists
        const existingIndex = prev.findIndex((m) => m.id === fullMessage.id)

        if (existingIndex >= 0) return prev

        // If this is our own message (sent by current user), check for optimistic message with tempId
        // that we need to replace. This handles the race condition where real-time INSERT fires
        // before postChatMessage() can replace the optimistic message
        if (fullMessage?.userid === userDetails?.id) {
          // Find optimistic message (has tempId-like structure or pending flag)
          const optimisticIndex = prev.findIndex((m) => (m.pending && m.community_id === fullMessage.community_id) || (typeof m.id === 'string' && m.id.startsWith('temp-') && m.community_id === fullMessage.community_id && m.userid === fullMessage.userid))

          if (optimisticIndex >= 0) {
            // Replace optimistic message with real one
            const newChats = [...prev]

            newChats[optimisticIndex] = { ...fullMessage, pending: false }

            return newChats
          }
        }

        // Message doesn't exist, add it

        return [...prev, fullMessage]
      })

      // Only increment unread count if message is from another user and we're not at bottom
      if (fullMessage?.userid !== userDetails?.id && !atBottomRef.current) {
        setUnreadCount((prev) => prev + 1)
      }
    }

    await supabase
      .from('community_members')
      .update({
        unread_count: 0,
        last_read_timestamp: new Date().toISOString()
      })
      .eq('userid', userDetails?.id)
      .eq('community_id', activeId)
  }

  function handleRealTimeBlockStatus(payload) {
    const blockedStatus = payload.new

    // Check if blocked changed to true
    if (blockedStatus?.userid === userDetails?.id && blockedStatus?.blocked) {
      setIsBlocked(true)
    } else if (blockedStatus?.userid === userDetails?.id && !blockedStatus?.blocked) {
      setIsBlocked(false)
    }

    // Update role if it changed
    if (blockedStatus?.userid === userDetails?.id && blockedStatus?.role !== undefined) {
      setUserRoleInCommunity(blockedStatus.role)
    }
  }

  const checkBlockedStatus = async () => {
    try {
      const { data } = await supabase.from('community_members').select('blocked').eq('community_id', activeCommunity.id).eq('userid', userDetails.id).single()

      setIsBlocked(data?.blocked === true)
    } catch (error) {
      console.log('Error Checking blocked status', error)
    }
  }

  const checkUserRole = async () => {
    try {
      const { data } = await supabase.from('community_members').select('role').eq('community_id', activeCommunity?.id).eq('userid', userDetails?.id).single()

      setUserRoleInCommunity(data?.role || null)
    } catch (error) {
      setUserRoleInCommunity(null)
    }
  }

  const init = async () => {
    const getAllShareListResponse = await apiAdapterCoffeeWeb.getAllShareList()
    // const getShortUrl = apiAdapterCoffeeWeb.shortenUrl(shareUrl)

    try {
      //   const [getAllShareListResponse, getShortUrlResponse] = await Promise.all([getAllShareList, getShortUrl])

      const activeSocialMediaListNames = getAllShareListResponse.data?.returnLst?.map((ele) => ele.shareName)

      //   setIsModalVisible(true)
      setActiveSocialMediaLists(activeSocialMediaListNames)
      //   setShortenUrl(getShortUrlResponse.data)
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  const getAllGroupsList = async () => {
    try {
      // Determine if the current user is an admin (can act as bot)
      let isAdmin = false

      if (userDetails?.id) {
        try {
          const { data } = await supabase.from('users').select('can_act_as_bot').eq('userid', userDetails?.id).single()

          isAdmin = !!data?.can_act_as_bot
          setIsAdminUser(isAdmin)
        } catch (err) {
          setIsAdminUser(false)
        }
      } else {
        setIsAdminUser(false)
      }
      const groupListResponse = userDetails ? await supabase.rpc('get_user_communities', { p_userid: userDetails?.id }) : await supabase.rpc('get_guest_communities', { p_country_id: 0 })
      const internalGroupList = await supabase.rpc('get_internal_communities', { p_userid: userDetails?.id || 0 })
      const { data, error } = await supabase.from('community_members').select('community_id, unread_count, role').eq('userid', userDetails?.id)

      const communityIds = groupListResponse.data?.map((item) => item.id)

      await supabase.rpc('add_user_to_community', { userid: userDetails?.id, community_ids: communityIds })

      const combinedGroupList = [...(groupListResponse.data || []), ...(internalGroupList.data || [])]

      const modifiedGroupList = combinedGroupList.map((item1) => {
        const match = data?.find((item2) => item2.community_id === item1.id)

        return {
          ...item1,
          unread_count: match ? match.unread_count : 0
        }
      })

      // Separate by sort_order
      const sortOrderZero = modifiedGroupList.filter((g) => !g.sort_order || g.sort_order === 0)
      const sortOrderNonZero = modifiedGroupList.filter((g) => g.sort_order && g.sort_order > 0).sort((a, b) => a.sort_order - b.sort_order)

      // Insert sortOrderNonZero at their index
      const finalList = [...sortOrderZero]

      sortOrderNonZero.forEach((g) => {
        // Clamp index to valid range
        const idx = Math.max(0, Math.min(g.sort_order, finalList.length))

        finalList.splice(idx, 0, g)
      })

      // Fetch settings for "Create Your Own Community"
      const { data: settingsData } = await supabase.from('kv_app_settings').select('create_community_count, community_instructions').limit(1).maybeSingle()
      const createCount = Number(settingsData?.create_community_count) || 0
      const instructions = settingsData?.community_instructions?.instructions || []

      setCreateCommunityInstructions(instructions)

      let extraCommunities = []

      if (createCount > 0) {
        extraCommunities = Array.from({ length: createCount }, (_, idx) => ({
          id: `create-own-${idx + 1}`,
          name: 'Create Your Own Community',
          community_url: '',
          subscription_details: [],
          isCreateOwn: true,
          instructions
        }))
      }

      let finalListWithExtras = [...finalList, ...extraCommunities]

      // Inject hardcoded admin-only "URL Approval" community at the top
      if (isAdmin) {
        const urlApprovalCommunity = {
          id: 'url-approval',
          name: 'Message Approval Process',
          community_url: '',
          subscription_details: [],
          isUrlApproval: true,
          isCreateOwn: false,
          unread_count: 0
        }

        finalListWithExtras = [urlApprovalCommunity, ...finalListWithExtras]
      }

      setGroupList(finalListWithExtras)
      setFilteredGroupList(finalListWithExtras)

      const params = new URLSearchParams(location.search)
      const requestedCommunityId = params.get('communityId')

      let initialCommunity = null

      if (requestedCommunityId) {
        initialCommunity = finalListWithExtras.find((item) => String(item.id) === requestedCommunityId) || null
      }

      if (!initialCommunity && finalListWithExtras.length > 0) {
        initialCommunity = finalListWithExtras[0]
      }

      if (initialCommunity) {
        setActiveId(initialCommunity.id)
        setActiveCommunity(initialCommunity)
        updateCommunitySearchParam(initialCommunity.id)
      } else {
        setActiveId('')
        setActiveCommunity(null)
        updateCommunitySearchParam(null)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsCommunitiesLoading(false)
    }
  }

  const invite = () => {
    setIsModalVisible(true)
  }

  const uploadToSupabaseStorage = async (file, communityName) => {
    const BUCKET_NAME = 'chat_media'
    const MAX_FILE_SIZE = 30 * 1024 * 1024 // 30 MB (Supabase bucket limit)
    const MAX_RETRIES = 3
    const RETRY_DELAY = 2000

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`File exceeds maximum size of ${MAX_FILE_SIZE / (1024 * 1024)}MB`)
    }

    if (file.size === 0) {
      throw new Error('File is empty')
    }

    // Generate file path with folder structure
    const sanitizeFileName = (name) =>
      name
        .replace(/[^\w\s\-.]/g, '_')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')

    const safeCommunityName = sanitizeFileName((communityName || '').trim())
    const timestamp = Date.now()
    const sanitizedFileName = sanitizeFileName(file.name)
    const uniqueFileName = `${timestamp}_${sanitizedFileName}`
    const filePath = safeCommunityName ? `${safeCommunityName}/${uniqueFileName}` : uniqueFileName

    // Retry logic with Promise.all to handle parallel uploads
    const uploadAttempt = async () => {
      // Use .upload() for all files (Supabase JS SDK handles buffering efficiently)
      const { data, error } = await supabase.storage.from(BUCKET_NAME).upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
        contentType: file.type || 'application/octet-stream'
      })

      if (error) {
        if (error.message.includes('duplicate') || error.message.includes('already exists')) {
          const { data: retryData, error: retryError } = await supabase.storage.from(BUCKET_NAME).upload(filePath, file, {
            cacheControl: '3600',
            upsert: true,
            contentType: file.type || 'application/octet-stream'
          })

          if (retryError) throw retryError
        } else {
          throw error
        }
      }

      // Get public URL
      const { data: urlData } = supabase.storage.from(BUCKET_NAME).getPublicUrl(filePath)
      const publicUrl = urlData.publicUrl

      return {
        url: publicUrl,
        media_url: publicUrl,
        s3_key: filePath,
        s3_bucket: BUCKET_NAME,
        name: file.name,
        mime: file.type,
        size: file.size
      }
    }

    // Implement retry logic using Promise and recursion instead of loop
    const attemptUpload = async (attemptsLeft) => {
      try {
        return await uploadAttempt()
      } catch (error) {
        if (attemptsLeft <= 1) {
          throw error
        }

        console.warn(`⚠️ Upload attempt failed, ${attemptsLeft - 1} retries remaining:`, error)

        // Create delay promise
        const delay = () =>
          new Promise((resolve) => {
            setTimeout(resolve, RETRY_DELAY)
          })

        // Wait for delay then recursively try again
        await delay()

        return attemptUpload(attemptsLeft - 1)
      }
    }

    // Start recursive retry chain
    try {
      return await attemptUpload(MAX_RETRIES)
    } catch (error) {
      throw error || new Error('Upload failed after maximum retry attempts')
    }
  }

  const onUpdateCaption = (id, { caption }) => {
    setAttachments((prev) => prev.map((att) => (att.id === id ? { ...att, caption } : att)))
  }

  const sendMessage = async () => {
    if (activeCommunity?.isCreateOwn || activeCommunity?.isUrlApproval) return

    const trimmedValue = value.trim()
    const hasAttachments = attachments.length > 0

    if ((!trimmedValue && !hasAttachments) || isBlocked) {
      if (isBlocked) setShowBlockedModal(true)

      return
    }

    if (!userDetails?.id) {
      setValue('')
      setAttachments([])
      setRepliedMessage(null)
      setShowRedirectText(true)

      return
    }

    const tempId = `temp-${Date.now()}`
    let uploadedAttachments = []

    // Prepare attachments for optimistic message (using preview URLs)
    const optimisticAttachments = attachments.map((att) => ({
      media_url: att.previewUrl || '',
      mime_type: att.mime || att.file?.type || '',
      file_name: att.name || att.file?.name || '',
      caption: att.caption || '',
      pending: true // Mark as pending for spinner
    }))

    // Detect URLs in message content and attachment captions for optimistic message
    const messageHasUrlOptimistic = hasUrlInMessage(value, attachments)

    // Create optimistic message with attachments
    const newMessage = {
      id: tempId,
      community_id: `${activeCommunity.id}`,
      userid: userDetails?.id,
      content: value.trim(),
      type: attachments.length ? 'file' : 'text',
      reply_to_id: repliedMessage?.id || null,
      repliedMessage: repliedMessage || null,
      timestamp: new Date().toISOString(),
      pending: true,
      has_url: messageHasUrlOptimistic,
      approved_status: messageHasUrlOptimistic ? 'PENDING' : null,
      attachments: optimisticAttachments,
      user_info: {
        userid: userDetails.id,
        first_name: userDetails.first_name || '',
        last_name: userDetails.last_name || '',
        users_flag_url: userDetails.users_flag_url || ''
      }
    }

    // Immediately clear attachments and show uploading state to switch to chat view
    const attachmentsToUpload = [...attachments]
    const repliedMsgRef = repliedMessage
    const inputValueRef = value

    // Clear state immediately to switch from AttachmentPreview to chat
    setAttachments([])
    setValue('')
    setRepliedMessage(null)
    setIsUploadingImage(true)

    // Add optimistic message to chat immediately
    setChats((prev) => [...prev, newMessage])

    // Scroll to bottom instantly (no delay) to show the new message immediately
    requestAnimationFrame(() => {
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight
      }
    })

    try {
      // If has attachments, upload them first
      if (attachmentsToUpload.length) {
        uploadedAttachments = await Promise.all(attachmentsToUpload.map((att) => uploadToSupabaseStorage(att.file, activeCommunity?.name)))
      }

      const attachmentsPayload = uploadedAttachments.map((att, index) => {
        const originalAttachment = attachmentsToUpload[index]

        return {
          caption: originalAttachment.caption || '',
          sort_order: index,
          s3_key: att.s3_key,
          s3_bucket: att.s3_bucket,
          file_name: originalAttachment.file.name,
          file_size: originalAttachment.file.size,
          mime_type: originalAttachment.file.type,
          media_url: att.media_url || att.url, // Use media_url if available, fallback to url
          thumbnail_url: '',
          metadata: {
            uploaded_at: new Date().toISOString(),
            original_file_name: originalAttachment.file.name,
            file_size: originalAttachment.file.size
          }
        }
      })

      // Detect URLs in message content and attachment captions
      const messageHasUrl = hasUrlInMessage(inputValueRef, attachmentsPayload)

      // Send message directly
      postChatMessage(newMessage, tempId, attachmentsPayload, messageHasUrl)

      // Cleanup: Revoke preview URLs after upload
      if (attachmentsToUpload.length) {
        attachmentsToUpload.forEach((a) => {
          if (a.previewUrl) URL.revokeObjectURL(a.previewUrl)
        })
      }

      // Reset textarea height
      const textAreaRef = inputRef.current

      if (textAreaRef) {
        textAreaRef.style.height = ''
        textAreaRef.style.overflowY = 'hidden'
      }

      // Scroll will be handled by postChatMessage after the message with images is updated
    } catch (err) {
      console.error('Failed to send message:', err)
      // Remove optimistic message on error
      setChats((prev) => prev.filter((msg) => msg.id !== tempId))
      alert('Failed to send message. Please try again.')
    } finally {
      setIsUploadingImage(false)
    }

    // const textAreaRef = inputRef.current

    // if (textAreaRef) {
    //   textAreaRef.style.height = '' // lets CSS min-height take over
    //   textAreaRef.style.overflowY = 'hidden'
    // }
  }

  const handleForwardToCommunity = async (communities) => {
    if (!communities || communities.length === 0) return
    if (!messageToForward) return
    if (!userDetails?.id) {
      setShowRedirectText(true)

      return
    }

    setIsForwarding(true)

    try {
      const forwardPromises = communities.map((community) => {
        const attachmentsPayload = (messageToForward.attachments || []).map((att, idx) => ({
          caption: att.caption || '',
          sort_order: idx,
          s3_key: att.s3_key || '',
          s3_bucket: att.s3_bucket || '',
          file_name: att.file_name || att.name || '',
          file_size: att.file_size || att.size || 0,
          mime_type: att.mime_type || att.type || '',
          media_url: att.media_url || att.url || '',
          thumbnail_url: att.thumbnail_url || '',
          metadata: att.metadata || {}
        }))

        return supabase.rpc('create_message_with_attachments', {
          p_community_id: community.id,
          p_user_id: userDetails.id,
          p_content: messageToForward.content || '',
          p_message_type: messageToForward.type || (attachmentsPayload.length ? 'file' : 'text'),
          p_reply_to_id: null,
          p_attachments: attachmentsPayload,
          p_is_forwarded: true
        })
      })

      await Promise.all(forwardPromises)

      const forwardedToActive = communities.some((c) => String(c.id) === String(activeCommunity?.id))

      if (forwardedToActive) {
        const tempIdBase = `forward-temp-${Date.now()}`

        communities
          .filter((c) => String(c.id) === String(activeCommunity?.id))
          .forEach((c, i) => {
            const tempId = `${tempIdBase}-${i}-${Math.random().toString(36).slice(2, 6)}`

            const forwardedMessage = {
              id: tempId,
              community_id: activeCommunity.id,
              userid: userDetails.id,
              content: messageToForward.content || '',
              type: messageToForward.type || ((messageToForward.attachments || []).length ? 'file' : 'text'),
              attachments: (messageToForward.attachments || []).map((att) => ({ ...att })),
              user_info: {
                userid: userDetails.id,
                first_name: userDetails.first_name || '',
                last_name: userDetails.last_name || '',
                users_flag_url: userDetails.users_flag_url || ''
              },
              is_forwarded: true,
              timestamp: new Date().toISOString(),
              pending: false,
              reply_to_id: null,
              repliedMessage: null
            }

            setChats((prev) => [...prev, forwardedMessage])
          })

        setTimeout(() => {
          scrollToBottom()
        }, 0)
      }

      setForwardModalVisible(false)
      setMessageToForward(null)
      setSelectedCommunitiesForForward([])
    } catch (err) {
      console.error('Forward failed', err)
    } finally {
      setIsForwarding(false)
    }
  }

  const scrollToBottom = (forceInstant = false) => {
    if (!containerRef.current) return

    const container = containerRef.current

    const scrollNow = (useSmooth = false) => {
      if (!container) return

      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      const maxScrollTop = scrollHeight - clientHeight

      container.scrollTo({
        top: maxScrollTop,
        behavior: forceInstant || !useSmooth ? 'auto' : 'smooth'
      })
    }

    // For instant scroll (like when adding optimistic message), skip media waiting
    if (forceInstant) {
      requestAnimationFrame(() => {
        scrollNow(false)
      })

      return
    }

    // Wait for images/videos to load before scrolling (for smooth scroll)
    const waitForMedia = () => {
      const images = container.querySelectorAll('img:not([src=""])')
      const videos = container.querySelectorAll('video:not([src=""])')
      const mediaElements = [...Array.from(images), ...Array.from(videos)]

      if (mediaElements.length === 0) {
        // No media, scroll immediately with smooth behavior
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollNow(true)
          })
        })

        return
      }

      let loadedCount = 0
      let hasPendingLoads = false
      const totalMedia = mediaElements.length

      const checkComplete = () => {
        loadedCount += 1
        if (loadedCount === totalMedia) {
          // All media loaded, scroll smoothly after rendering
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              scrollNow(true)
            })
          })
        }
      }

      // Check which images are already loaded
      mediaElements.forEach((media) => {
        if (media.complete || (media.tagName === 'VIDEO' && media.readyState >= 2)) {
          // Already loaded
          checkComplete()
        } else {
          hasPendingLoads = true
          // Wait for load
          const onLoad = () => checkComplete()
          const onError = () => checkComplete()

          media.addEventListener('load', onLoad, { once: true })
          media.addEventListener('error', onError, { once: true })
          if (media.tagName === 'VIDEO') {
            media.addEventListener('loadeddata', onLoad, { once: true })
          }
        }
      })

      // If all were already loaded (no pending loads)
      if (!hasPendingLoads && loadedCount === totalMedia) {
        checkComplete()
      }

      // Fallback: scroll after max 800ms even if images haven't loaded (reduced from 1500ms)
      setTimeout(() => {
        scrollNow(true)
      }, 800)
    }

    // Use requestAnimationFrame to ensure DOM has updated
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        waitForMedia()
      })
    })
  }

  const scrollToMessage = (messageId) => {
    if (!containerRef.current || !messageId) return

    const messageElement = document.getElementById(`msg-${messageId}`)

    if (messageElement) {
      // Scroll to the message
      messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })

      // Highlight the message temporarily
      messageElement.classList.add('highlight-message')
      setTimeout(() => {
        messageElement.classList.remove('highlight-message')
      }, 2000)
    } else {
      // If message is not in DOM (might be in older messages), try to load it
      console.log('Message not found in current view, might need to load older messages')
    }
  }

  const postChatMessage = async (chatMessageBody, tempId, attachments = [], hasUrl = false) => {
    try {
      const { repliedMessage, id, pending, ...bodyToSend } = chatMessageBody

      // Map attachments to include captions from UI state
      const attachmentsWithCaptions = attachments.map((att, index) => {
        const uiAttachment = attachments.find((a) => a.file_name === att.file_name)

        return {
          ...att,
          caption: uiAttachment?.caption || '',
          sort_order: index
        }
      })

      // Create message with attachments and reply_to_id
      const { data, error } = await supabase.rpc('create_message_with_attachments', {
        p_community_id: activeCommunity?.id,
        p_user_id: userDetails?.id,
        p_content: bodyToSend.content || '',
        p_message_type: bodyToSend.type,
        p_reply_to_id: bodyToSend.reply_to_id || null, // Make sure to include this
        p_attachments: attachmentsWithCaptions,
        p_is_forwarded: false
      })

      if (error) throw error

      // Fetch the newly created message using the RPC to get real ID and structure
      const { data: newMessage } = await supabase.rpc('get_community_messages_with_attachments', {
        p_community_id: activeCommunity?.id,
        p_user_id: userDetails?.id,
        p_limit: 1,
        p_offset: 0
      })

      if (newMessage?.messages?.[0]) {
        const latestMessage = newMessage.messages[0]

        // If message has URL, update it with has_url flag and set approval status
        if (hasUrl && latestMessage.id) {
          await supabase
            .from('messages')
            .update({
              has_url: true,
              approved_status: 'PENDING'
            })
            .eq('id', latestMessage.id)

          // Update the latestMessage object with the new values
          latestMessage.has_url = true
          latestMessage.approved_status = 'PENDING'
        }

        // ========== APPLY SAME REPLY LOGIC AS fetchOlderChats ==========
        let processedRepliedMessage = null

        // Pre-fetch reply user if we have an ID (even when deleted)
        let replyUser = null

        if (latestMessage.reply_user_id) {
          const { data: userInfo } = await supabase.from('users').select('userid, first_name, last_name, users_flag_url').eq('userid', latestMessage.reply_user_id).single()

          replyUser = userInfo || null
        }

        // if (latestMessage.reply_to_id && (latestMessage.reply_content || latestMessage.is_reply_deleted)) {
        if (latestMessage.reply_to_id) {
          if (latestMessage.is_reply_deleted) {
            // Reply is deleted - show "Message deleted" but keep user name
            processedRepliedMessage = {
              id: latestMessage.reply_to_id,
              content: null, // This will trigger "Message deleted" in UI
              userid: latestMessage.reply_user_id,
              attachmentsType: repliedMessage?.attachments[0]?.attachment_type || repliedMessage?.attachments[0]?.media_type,
              attachmentsCount: repliedMessage?.attachments?.length,
              user: replyUser || {
                userid: latestMessage.reply_user_id,
                first_name: 'User',
                last_name: '',
                users_flag_url: ''
              }
            }
          } else {
            // Reply exists
            processedRepliedMessage = {
              id: latestMessage.reply_to_id,
              content: latestMessage.reply_content,
              userid: latestMessage.reply_user_id,
              attachmentsType: repliedMessage?.attachments[0]?.attachment_type || repliedMessage?.attachments[0]?.media_type,
              attachmentsCount: repliedMessage?.attachments?.length,

              user: replyUser || {
                userid: latestMessage.reply_user_id,
                first_name: 'User',
                last_name: '',
                users_flag_url: ''
              }
            }
          }
        }

        // Preload images before updating to prevent blank screen
        const preloadPromises = (latestMessage.attachments || [])
          .filter((att) => att.media_url && (att.mime_type?.startsWith('image/') || att.mime_type?.startsWith('video/')))
          .map(
            (att) =>
              new Promise((resolve) => {
                if (att.mime_type?.startsWith('image/')) {
                  const img = new Image()

                  img.onload = () => resolve()
                  img.onerror = () => resolve() // Resolve even on error to not block
                  img.src = att.media_url
                } else if (att.mime_type?.startsWith('video/')) {
                  const video = document.createElement('video')

                  video.onloadeddata = () => resolve()
                  video.onerror = () => resolve()
                  video.src = att.media_url
                } else {
                  resolve()
                }
              })
          )

        // Wait for images to preload (with timeout)
        await Promise.race([
          Promise.all(preloadPromises),
          new Promise((resolve) => {
            setTimeout(() => {
              resolve()
            }, 500) // Max 500ms wait
          })
        ])

        // Build the complete message with proper reply structure
        const completeMessage = {
          ...latestMessage,
          repliedMessage: processedRepliedMessage,
          pending: false,
          // Ensure attachments don't have pending flag
          attachments: (latestMessage.attachments || []).map((att) => ({
            ...att,
            pending: false
          }))
        }

        // Replace pending message with the real one (images are now preloaded)
        setChats((prev) => prev.map((msg) => (msg.id === tempId ? completeMessage : msg)))

        // Smooth scroll after images are loaded and rendered
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (containerRef.current) {
              containerRef.current.scrollTo({
                top: containerRef.current.scrollHeight,
                behavior: 'smooth'
              })
            }
          })
        })
      }
    } catch (error) {
      // Remove the pending message on error
      setChats((prev) => prev.filter((msg) => msg.id !== tempId))
      console.log('Error creating message:', error)
      throw error // Re-throw to handle in sendMessage
    }
  }

  // const checkIfUserIsAdmin = async () => {
  //   try {
  //     const { data } = await supabase.from('users').select('can_act_as_bot').eq('userid', userDetails?.id).single()

  //     const isAdmin = !!data?.can_act_as_bot

  //     setIsAdminUser(isAdmin)

  //     return isAdmin
  //   } catch (error) {
  //     console.log('Error checking admin status:', error)
  //     setIsAdminUser(false)

  //     return false
  //   }
  // }

  const handleCopyClick = () => {
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 3000)
  }

  const handleCommunitySearch = (value) => {
    setSearchCommunityTerm(value)

    if (!value.trim()) {
      setFilteredGroupList(groupList)
    } else {
      const filteredList = groupList.filter((group) => group.name.toLowerCase().includes(value.toLowerCase()))

      setFilteredGroupList(filteredList)
    }
  }

  const handleChange = (newValue) => {
    // const formattedValue = newValue.charAt(0).toUpperCase() + newValue.slice(1)

    setValue(newValue)

    const textAreaRef = inputRef.current

    if (textAreaRef) {
      textAreaRef.style.height = 'auto'
      const CAP = 100
      const newHeight = Math.min(textAreaRef.scrollHeight, CAP)

      textAreaRef.style.height = `${newHeight}px`
      textAreaRef.style.overflowY = textAreaRef.scrollHeight > CAP ? 'auto' : 'hidden'
    }
  }

  const handleInChatSearch = () => {}

  const renderMainContent = () => {
    if (activeCommunity?.isUrlApproval) {
      return (
        <div className="url-approval-panel">
          <div className="url-approval-header">
            <h3 className="url-approval-title">URL Approval Queue</h3>
            <p className="url-approval-subtitle">Review and approve or reject URLs shared in communities.</p>
          </div>

          <div className="url-approval-content">
            {pendingUrlsError && <div className="url-approval-error">{pendingUrlsError}</div>}

            {!pendingUrlsError && pendingUrlMessages.length === 0 && (
              <div className="url-approval-empty">
                <p>No URLs require your approval right now.</p>
              </div>
            )}

            {pendingUrlMessages.length > 0 && (
              <div className="url-approval-list">
                {pendingUrlMessages.map((msg) => {
                  const isPending = msg.approved_status === 'PENDING'
                  const isApproved = msg.approved_status === 'APPROVED'
                  const isRejected = msg.approved_status === 'REJECTED'

                  // Derive latest admin name from approving / declining admins
                  let adminName = ''
                  const approvingAdmins = Array.isArray(msg.approving_admins) ? msg.approving_admins : []
                  const decliningAdmins = Array.isArray(msg.declining_admins) ? msg.declining_admins : []

                  if (isApproved && approvingAdmins.length) {
                    const last = approvingAdmins[approvingAdmins.length - 1]

                    adminName = `${last.first_name || ''} ${last.last_name || ''}`.trim()
                  } else if (isRejected && (decliningAdmins.length || approvingAdmins.length)) {
                    const source = decliningAdmins.length ? decliningAdmins : approvingAdmins
                    const last = source[source.length - 1]

                    adminName = `${last.first_name || ''} ${last.last_name || ''}`.trim()
                  }

                  let statusClass = ''

                  if (isPending) statusClass = 'pending'
                  else if (isApproved) statusClass = 'approved'
                  else if (isRejected) statusClass = 'rejected'

                  // Extract all URLs from message content and attachment captions
                  const allUrls = []

                  if (msg.content) {
                    allUrls.push(...extractUrls(msg.content))
                  }
                  if (msg.caption) {
                    allUrls.push(...extractUrls(msg.caption))
                  }
                  if (Array.isArray(msg.attachments)) {
                    msg.attachments.forEach((att) => {
                      if (att.caption) {
                        allUrls.push(...extractUrls(att.caption))
                      }
                    })
                  }
                  // Remove duplicates
                  const uniqueUrls = [...new Set(allUrls)]

                  return (
                    <div key={msg.id} className="url-card">
                      <div className="url-card-header">
                        <div className="url-card-user">
                          <div className="url-card-user-name">
                            {msg.user_first_name} {msg.user_last_name}
                          </div>
                          <div className="url-card-community">{msg.community_name}</div>
                        </div>
                        <div className={`url-card-status ${statusClass}`}>
                          {isPending && 'Pending'}
                          {isApproved && 'Approved'}
                          {isRejected && 'Rejected'}
                        </div>
                      </div>

                      <div className="url-card-body">
                        {uniqueUrls.length > 0 ? (
                          <ul className="url-list" style={{ listStyle: 'disc', paddingLeft: '20px', margin: 0 }}>
                            {uniqueUrls.map((url, index) => (
                              <li key={index} style={{ marginBottom: '8px', wordBreak: 'break-all' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                  <a href={url} target="_blank" rel="noreferrer" style={{ flex: 1 }}>
                                    {url}
                                  </a>
                                  {copiedUrlId === `${msg.id}-${index}` ? (
                                    <span style={{ color: '#4caf50', fontSize: '14px', fontWeight: 500 }}>Copied</span>
                                  ) : (
                                    <i
                                      className="pi pi-copy url-copy-icon"
                                      onClick={async () => {
                                        try {
                                          await navigator.clipboard?.writeText(url)
                                          setCopiedUrlId(`${msg.id}-${index}`)
                                          setTimeout(() => {
                                            setCopiedUrlId(null)
                                          }, 2000)
                                        } catch (err) {
                                          console.error('Failed to copy URL:', err)
                                        }
                                      }}
                                      title="Copy URL"
                                      style={{ cursor: 'pointer', flexShrink: 0 }}
                                    />
                                  )}
                                </div>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="url-card-url" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <span style={{ color: '#999' }}>No URLs found</span>
                          </div>
                        )}
                        {msg.caption && <div className="url-card-caption">{msg.caption}</div>}
                      </div>

                      <div className="url-card-footer">
                        {isPending ? (
                          <div className="url-card-actions">
                            <Button label="Reject" className="p-button url-card-btn url-card-btn-reject" disabled={isUrlActionLoading} onClick={() => handleUrlApprovalAction(msg, 'reject')} />
                            <Button label="Approve" className="p-button url-card-btn url-card-btn-approve" disabled={isUrlActionLoading} onClick={() => handleUrlApprovalAction(msg, 'approve')} />
                          </div>
                        ) : (
                          adminName && (
                            <div className="url-card-admin-info">
                              {isApproved && <span>Approved by {adminName}</span>}
                              {isRejected && <span>Rejected by {adminName}</span>}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      )
    }

    if (attachments.length > 0 && !isUploadingImage) {
      return <AttachmentPreview attachments={attachments} scrollToBottom={scrollToBottom} removeAttachment={removeAttachment} setAttachments={setAttachments} addFiles={addFiles} handleMediaSelected={handleMediaSelected} onSendAttachments={sendMessage} onUpdateAttachment={onUpdateCaption} isUploadingImage={isUploadingImage} />
    }

    return (
      <>
        <div className="chat-messages" ref={containerRef}>
          <div className={`top-loader ${isFetchingOlder ? 'show' : ''}`} aria-live="polite" aria-busy={isFetchingOlder}>
            <i className="pi pi-spinner pi-spin" />
            <span>Loading messages…</span>
          </div>

          {activeCommunity?.isCreateOwn ? (
            <div className="create-community-card">
              <div className="create-community-card__title">Create Your Own Community</div>
              <div className="create-community-card__instructions">
                {instructionsForCreateCommunity.length ? (
                  instructionsForCreateCommunity.map((item, idx) => (
                    <div key={`${item?.title || 'instruction'}-${idx}`} className="create-community-card__item">
                      <div className="create-community-card__item-title">{item?.title || 'Instruction'}</div>
                      <div className="create-community-card__item-description">
                        {item?.description?.split('\n').map((line, index) => (
                          <div key={index} className="description-line">
                            {line?.includes('@') ? <strong>{line.trim()}</strong> : line}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="create-community-card__item-description">No instructions available.</div>
                )}
              </div>
            </div>
          ) : (
            groupedMessages.map(([date, msgs]) => (
              <div key={date} className="date-group">
                <div className="date-separator">{!isFetchingOlder && <span className="date-label">{date}</span>}</div>
                {msgs
                  .filter((msg) => {
                    // Filter messages based on approval status
                    // If message has URL and is pending, only show to sender
                    if (msg?.has_url && msg?.approved_status === 'PENDING') {
                      return msg?.userid === userDetails?.id
                    }
                    // Show all other messages

                    return true
                  })
                  .map((msg) => {
                    const isOutgoing = msg?.userid === userDetails?.id
                    const isPendingApproval = msg?.has_url && msg?.approved_status === 'PENDING'

                    const ALLOWED_DURATION = 5 * 60 * 1000 // 5 minutes in milliseconds
                    const isActionAllowed = (isOutgoing && new Date() - new Date(msg?.timestamp) <= ALLOWED_DURATION) || msg?.attachments?.length > 0

                    const incomingMenuNode = !isOutgoing ? (
                      <MessageMenu
                        placement="bottom-start"
                        onReply={() => handleReply(msg, setRepliedMessage, repliedMsgRef, inputRef)}
                        onCopy={() => navigator.clipboard?.writeText(msg.content).catch(() => {})}
                        onReact={() => {}}
                        onForward={() => openForwardModal(msg)}
                        onPin={() => {}}
                        onStar={() => {}}
                        onAddNote={() => {}}
                        onReport={() => {}}
                        onEdit={() => openConfirmationModal('edit', msg)}
                        onDeleteForMe={() => openConfirmationModal('deleteForMe', msg)}
                        onDeleteForEveryone={() => openConfirmationModal('deleteForEveryone', msg)}
                        onDeleteMessageByAdmin={() => openConfirmationModal('deleteMessageByAdmin', msg)}
                        onDeleteAllMessageByAdmin={() => openConfirmationModal('deleteAllMessageByAdmin', msg)}
                        onBlockUserByAdmin={() => openConfirmationModal('blockUserByAdmin', msg)}
                        onReportAbuse={() => openConfirmationModal('reportAbuse', msg)}
                        onUndoReportAbuse={() => handleUndoReportAbuse(msg)}
                        isActionAllowed={isActionAllowed}
                        isAdminUser={isAdminUser}
                        reportAbuseOption={msg?.user?.can_act_as_bot}
                        isOwnMessage={isOutgoing}
                        hasAttachments={msg?.attachments?.length > 0}
                        isReportedByMe={msg?.is_reported_by_me}
                        isPendingApproval={isPendingApproval}
                      />
                    ) : null

                    return (
                      <div key={msg.id} className={`msg ${isOutgoing ? 'out' : 'in'}`} id={`msg-${msg.id}`}>
                        <ChatMessage msg={msg} isOutgoing={isOutgoing} formatTime={formatTime} setRepliedMessage={setRepliedMessage} onAttachmentClick={openViewer} menuNode={incomingMenuNode} onReplyClick={scrollToMessage} activeCommunity={activeCommunity} userRoleInCommunity={userRoleInCommunity} />
                        {isOutgoing && (
                          <div className={`message-options ${msg.pending ? 'invisible' : 'visible'}`}>
                            <MessageMenu
                              placement="bottom-end"
                              onReply={() => handleReply(msg, setRepliedMessage, repliedMsgRef, inputRef)}
                              onCopy={() => navigator.clipboard?.writeText(msg.content).catch(() => {})}
                              onReact={() => {}}
                              onForward={() => openForwardModal(msg)}
                              onPin={() => {}}
                              onStar={() => {}}
                              onAddNote={() => {}}
                              onReport={() => {}}
                              onEdit={() => openConfirmationModal('edit', msg)}
                              onDeleteForMe={() => openConfirmationModal('deleteForMe', msg)}
                              onDeleteForEveryone={() => openConfirmationModal('deleteForEveryone', msg)}
                              onDeleteMessageByAdmin={() => openConfirmationModal('deleteMessageByAdmin', msg)}
                              onDeleteAllMessageByAdmin={() => openConfirmationModal('deleteAllMessageByAdmin', msg)}
                              onBlockUserByAdmin={() => openConfirmationModal('blockUserByAdmin', msg)}
                              onReportAbuse={() => openConfirmationModal('reportAbuse', msg)}
                              isActionAllowed={isActionAllowed}
                              isAdminUser={isAdminUser}
                              reportAbuseOption={msg?.user?.can_act_as_bot}
                              isOwnMessage={isOutgoing}
                              hasAttachments={msg?.attachments?.length > 0}
                              isPendingApproval={isPendingApproval}
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}
              </div>
            ))
          )}
        </div>

        <div className="chat-input">
          <ScrollPageToBottom />

          {!showRedirectText ? (
            <>
              {/* Check if community is admin-only and user is not admin */}
              {activeCommunity?.admin_only_message && userRoleInCommunity !== 'ADMIN' ? (
                <div className="redirect-login-text">
                  <p>{t('ADMIN_ONLY_MESSAGE')}</p>
                </div>
              ) : (
                <div className={`input-wrapper ${activeCommunity?.isCreateOwn ? 'disabled-wrapper' : ''}`}>
                  {repliedMessage && (
                    <div className="reply-preview">
                      <div className="reply-header-container">
                        <div className="reply-header">
                          <p className="replying-to">{repliedMessage?.userid === userDetails?.id ? 'Replying to you' : `Replying to ${repliedMessage?.user_info?.first_name || repliedMessage?.user?.first_name || 'User'}`}</p>
                        </div>
                        <div className="reply-attachment-container">
                          {repliedMessage?.attachments?.length > 0 && (
                            <div className="reply-body with-attachment">
                              <div className="attachment-info">
                                <div className="photo-info">
                                  {(repliedMessage?.attachments[0]?.attachment_type === 'image' || repliedMessage?.attachments[0]?.media_type === 'image') && <i className="pi pi-camera"></i>}
                                  {(repliedMessage?.attachments[0]?.attachment_type === 'video' || repliedMessage?.attachments[0]?.media_type === 'video') && <i className="pi pi-video"></i>}
                                  {(repliedMessage?.attachments[0]?.attachment_type === 'document' || repliedMessage?.attachments[0]?.media_type === 'document') && <i className="pi pi-file-pdf"></i>}

                                  <span>
                                    {(repliedMessage?.attachments[0]?.attachment_type === 'image' || repliedMessage?.attachments[0]?.media_type === 'image') && 'Photo'}
                                    {(repliedMessage?.attachments[0]?.attachment_type === 'video' || repliedMessage?.attachments[0]?.media_type === 'video') && 'Video'}
                                    {(repliedMessage?.attachments[0]?.attachment_type === 'document' || repliedMessage?.attachments[0]?.media_type === 'document') && 'Document'}
                                    {repliedMessage.attachments.length > 1 ? ` (+${repliedMessage.attachments.length - 1})` : ''}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <p className="reply-caption">{repliedMessage?.content || repliedMessage?.attachments?.[0]?.caption}</p>
                      </div>
                      <div className="reply-attachment-image-container">
                        <div> {(repliedMessage?.attachments?.[0]?.attachment_type === 'image' || repliedMessage?.attachments[0]?.media_type === 'image') && <img src={repliedMessage.attachments[0]?.attachment_url || repliedMessage.attachments[0]?.media_url} className="reply-attachment-thumbnail" alt="attachment thumbnail" />}</div>
                        <button className="cancel-reply-btn" onClick={() => setRepliedMessage(null)}>
                          ✕
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="input-area">
                    <AttachmentMenu setShowRedirectText={!userDetails?.id ? setShowRedirectText : false} ref={uploaderRef} onMediaSelected={handleMediaSelected} onDocumentSelected={handleDocumentSelected} />

                    <div className="input-area-container">
                      <div>
                        <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png" alt="coffee-web-logo" className="input-logo" />
                      </div>
                      <InputTextarea ref={inputRef} rows={isWebView ? 1 : 2} cols={1} value={value} onKeyDown={(e) => handleKeyDown(e)} onChange={(e) => handleChange(e.target.value)} placeholder={`${placeholderText()}...`} className="input-field" />
                    </div>
                    <Button rounded icon="pi pi-send send-icon" className="send-button" onClick={sendMessage} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="redirect-login-text">
              Please <span onClick={handleLogin}>{t('LOGIN_AND_CREATE_ACCOUNT')}</span> to Join the Conversation
            </div>
          )}
        </div>
      </>
    )
  }

  // ---------- URL APPROVAL HELPERS ----------

  const fetchPendingUrlMessages = React.useCallback(async () => {
    if (!userDetails?.id) return

    setPendingUrlsError(null)

    try {
      const { data, error } = await supabase.rpc('get_pending_url_messages', {
        p_admin_user_id: userDetails?.id
      })

      if (error) {
        throw error
      }

      // RPC can return either a plain array of rows or an object wrapper.
      let list = []

      if (Array.isArray(data)) {
        list = data
      } else if (data && Array.isArray(data.messages)) {
        list = data.messages
      } else if (data && Array.isArray(data.pending_messages)) {
        list = data.pending_messages
      }

      setPendingUrlMessages(list)
    } catch (err) {
      console.error('Error fetching pending URL messages:', err)
      setPendingUrlsError('Unable to load pending URLs. Please try again.')
    }
  }, [userDetails?.id])

  const handleUrlApprovalAction = async (message, action) => {
    if (!message?.id || !userDetails?.id) return
    if (isUrlActionLoading) return

    setIsUrlActionLoading(true)

    try {
      if (action === 'approve') {
        const { error } = await supabase.rpc('approve_message_url', {
          p_message_id: message.id,
          p_admin_user_id: userDetails?.id
        })

        if (error) throw error
      } else if (action === 'reject') {
        const { error } = await supabase.rpc('reject_message_url', {
          p_message_id: message.id,
          p_admin_user_id: userDetails?.id
        })

        if (error) throw error
      }

      // Real-time handler will automatically refresh the list when status changes
    } catch (err) {
      console.error(`Error performing URL ${action}:`, err)
    } finally {
      setIsUrlActionLoading(false)
    }
  }

  useEffect(() => {
    if (!activeCommunity?.isUrlApproval || !isAdminUser || !userDetails?.id) return

    fetchPendingUrlMessages()
  }, [activeCommunity?.id, activeCommunity?.isUrlApproval, isAdminUser, userDetails?.id, fetchPendingUrlMessages])

  // Real-time subscription for URL approval panel
  useEffect(() => {
    if (!activeCommunity?.isUrlApproval || !isAdminUser || !userDetails?.id) return

    const channel = supabase
      .channel('url-approval-realtime')
      // Listen for new messages with pending URLs
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: 'has_url=eq.true'
        },
        async (payload) => {
          const newMessage = payload.new
          // Only refresh if the message is pending

          if (newMessage.approved_status === 'PENDING') {
            await fetchPendingUrlMessages()
          }
        }
      )
      // Listen for approval status updates
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'messages',
          filter: 'has_url=eq.true'
        },
        async (payload) => {
          const updatedMessage = payload.new
          // Refresh list when approval status changes (approved/rejected)
          // Only refresh when status changes from PENDING to APPROVED/REJECTED

          if (updatedMessage.approved_status !== 'PENDING') {
            await fetchPendingUrlMessages()
          }
        }
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          // console.log('Realtime subscribed for URL approval panel')
        }
      })

    return () => {
      supabase.removeChannel(channel)
    }
  }, [activeCommunity?.isUrlApproval, isAdminUser, userDetails?.id, fetchPendingUrlMessages])

  let modalTitle = 'Confirm'

  if (modalAction === 'edit') {
    modalTitle = 'Edit Message'
  } else if (modalAction === 'deleteForMe') {
    modalTitle = 'Delete Message For Me'
  } else if (modalAction === 'deleteForEveryone') {
    modalTitle = 'Delete Message For Everyone'
  } else if (modalAction === 'deleteMessageByAdmin') {
    modalTitle = "Delete User's Message" // eslint-disable-line quotes
  } else if (modalAction === 'deleteAllMessageByAdmin') {
    modalTitle = "Delete User's All Message" // eslint-disable-line quotes
  } else if (modalAction === 'blockUserByAdmin') {
    modalTitle = 'Block User'
  } else if (modalAction === 'reportAbuse') {
    modalTitle = 'Report Abuse'
  }

  const shareListModalContent = () => (
    <div className="share-news-feed" data-testid="share-news-feed-main-container">
      {activeSocialMediaLists.includes('Copy') && (
        <div className="share-news-feed-container" data-testid="copy-container">
          <div className="icon-container copy-button" onClick={handleCopyClick} data-testid="copy-icon-container">
            <i className="pi pi-copy copy-icon" quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} value={shortenUrl} data-testid="tool-tip" />
          </div>
          <p className="icons-text" onClick={handleCopyClick}>
            {t('COPY')}
          </p>
          <Tooltip target=".copy-button" position="bottom" content={'Coming Soon'} className="copy-tooltip" />
        </div>
      )}

      {/* Commented for WhatsApp as per discussion */}
      {/* {activeSocialMediaLists.includes('WhatsApp') && (
        <div className="share-news-feed-container" data-testid="whats-app-container">
          <WhatsappShareButton url={shareLinksFowWhatsApp} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitleForWhatsApp} media={imgUrl}>
            <div className="icon-container" data-testid="whatsapp-icon-container">
              <i className="pi pi-whatsapp whatsapp-icon" />
            </div>
            <p className="icons-text">{t('WHATS_APP')}</p>
          </WhatsappShareButton>
          <Tooltip target=".whatsapp-icon" position="bottom" content={'Coming Soon'} className="copy-tooltip" />
        </div>
      )} */}

      {activeSocialMediaLists.includes('WhatsApp') && (
        <div className="share-news-feed-container" data-testid="whats-app-container">
          <div className="icon-container" data-testid="whatsapp-icon-container" style={{ cursor: 'pointer', pointerEvents: 'auto' }}>
            <i className="pi pi-whatsapp whatsapp-icon" />
          </div>
          <p className="icons-text">{t('WHATS_APP')}</p>
          <Tooltip target=".whatsapp-icon" position="bottom" content="Coming Soon" className="copy-tooltip" />
        </div>
      )}

      {activeSocialMediaLists.includes('Facebook') && (
        <div className="social-media-div">
          <FacebookShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <FacebookIcon size={40} round={true} />
            <p className="icons-text">{t('FACEBOOK')}</p>
          </FacebookShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('LinkedIn') && (
        <div className="social-media-div">
          <LinkedinShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <LinkedinIcon size={40} round={true} />
            <p className="icons-text">{t('LINKED_IN')}</p>
          </LinkedinShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Twitter') && (
        <div className="social-media-div">
          <TwitterShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <TwitterIcon size={40} round={true} />
            <p className="icons-text">{t('TWITTER')}</p>
          </TwitterShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Telegram') && (
        <div className="social-media-div">
          <TelegramShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <TelegramIcon size={40} round={true} />
            <p className="icons-text">{t('TELEGRAM')}</p>
          </TelegramShareButton>
        </div>
      )}
      {activeSocialMediaLists.includes('Email') && (
        <div className="social-media-div">
          <EmailShareButton url={shortenUrl} quote={`"${newsTitle}" - Check out the full article at ${shortenUrl}`} hashtag={'#portfolio...'} title={newsTitle} media={imgUrl}>
            <EmailIcon size={40} round={true} />
            <p className="icons-text">{t('MAIL')}</p>
          </EmailShareButton>
        </div>
      )}
    </div>
  )

  const getSubscriptionLabelColor = (ele) => {
    const colorCodes = ele?.subscription_colors || []

    return `linear-gradient(100deg, ${colorCodes[0]}, ${colorCodes[1]}, ${colorCodes[2]})`
  }

  const ScrollPageToBottom = () => (
    <div className="scroll-to-bottom-container">
      {showScrollButton && (
        <div className="scroll-to-bottom-icon">
          <i className="pi pi-angle-double-down scroll-button" onClick={scrollToBottom} />
          {unreadCount > 0 && <span className="unread-count-badge">{unreadCount}</span>}
        </div>
      )}
    </div>
  )

  const CommunitySubscriptionTypes = ({ subTypes }) =>
    isCommunitiesLoading ? (
      <div className="subscription-skeleton">
        <Skeleton className="custom-skelton" width="10rem" height="2rem"></Skeleton>
      </div>
    ) : (
      <div className="published_for_div">
        <div className="published_for_sub_div" data-testid="subscription-code">
          {subTypes?.map((ele, index) => (
            <React.Fragment key={index}>
              {ele?.subscription_code && (
                <span
                  className="eachLabeling"
                  style={{
                    backgroundSize: '400% 400%',
                    backgroundImage: getSubscriptionLabelColor(ele),
                    animation: 'gradient 7s ease infinite',
                    color: 'white',
                    borderRadius: '4px',
                    fontSize: '8px',
                    padding: '1px 4px',
                    margin: '1px 2px'
                  }}
                >
                  {ele?.subscription_code}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    )

  const placeholderText = () => {
    if (!activeCommunity?.name) return 'Loading'

    // Split name into words
    const words = activeCommunity.name.split(/\s+/)

    if (words.length === 1) {
      // If single word, just append Talks
      return `${words[0]} Talks`
    }

    // Replace last word with Talks and join back
    words[words.length - 1] = 'Talks'

    return words.join(' ')
  }

  const instructionsForCreateCommunity = activeCommunity?.isCreateOwn ? activeCommunity?.instructions || createCommunityInstructions || [] : []

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }

  const handleEditKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && editValue.trim()) {
      e.preventDefault()
      handleModalConfirm()
    }
  }

  const handleDragStart = (event, index) => {
    event.dataTransfer.setData('draggedIndex', index)
  }

  const handleDrop = async (event, index) => {
    event.preventDefault()

    const draggedIdx = Number(event.dataTransfer.getData('draggedIndex'))

    if (Number.isNaN(draggedIdx) || draggedIdx === index) {
      return
    }

    // Use the latest filteredGroupList for reordering
    const updatedRows = [...filteredGroupList]
    const [draggedItem] = updatedRows.splice(draggedIdx, 1)

    updatedRows.splice(index, 0, draggedItem)

    const sortedPayload = updatedRows.map((el, index) => ({
      community_id: el?.id,
      sort_order: index
    }))

    await supabase.rpc('sort_community', { p_userid: userDetails?.id, p_items: sortedPayload })

    setGroupList(updatedRows)
    setFilteredGroupList(updatedRows)
  }

  const handleCommunityClickAction = (communityData) => {
    if (!communityData) return

    updateCommunitySearchParam(communityData.id)

    if (String(communityData.id) === String(activeId)) return // To handle clicked the already active one

    setActiveCommunity(communityData)
    setActiveId(communityData.id)
    // setChats([])
    setValue('')
    setRepliedMessage(null)
    setAttachments([])
    setUserRoleInCommunity(null) // Reset role when switching communities
    // Clear URL approval specific state when switching away
    setPendingUrlMessages([])
    setPendingUrlsError(null)

    // Reset preview URLs to prevent memory leaks
    attachments.forEach((att) => {
      if (att.previewUrl) {
        URL.revokeObjectURL(att.previewUrl)
      }
    })

    // inside the effect that runs on activeCommunity?.id change (you already do some reset)
    isInitialLoadRef.current = true
    hasMoreRef.current = true
    nextCursorRef.current = null
    earliestTimestampRef.current = null
    existingIdsRef.current = new Set()
    // setNextCursor(null) // Commented if chat scroll through cursor
    setChats([])
  }

  const handleLogin = () => {
    if (userLoginStatus === false) {
      history.push(ROUTE_STRINGS.login)
    } else {
      history.push(ROUTE_STRINGS.createAccount)
    }
  }

  function CommunitiesSkeleton() {
    return (
      <div className="skeleton-card">
        <div className="skeleton-container">
          <div>
            <Skeleton className="custom-skelton" shape="circle" size="2.25rem"></Skeleton>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', gap: '0.25rem', alignItems: 'center' }}>
            <Skeleton className="custom-skelton" width="100%" height="2rem"></Skeleton>
            <Skeleton className="custom-skelton" shape="circle" size="1rem"></Skeleton>
          </div>
        </div>
      </div>
    )
  }

  function ReceivedMessageSkeleton() {
    return (
      <div className="message-row received" aria-hidden="true">
        <div className="avatar">
          <Skeleton className="custom-skeleton" shape="circle" size="40px" />
        </div>

        <div className="skeleton-bubble">
          <div className="skeleton-bubble-header">
            <Skeleton className="custom-skeleton" width="8rem" height="0.75rem" />
          </div>

          <div className="skeleton-bubble-body">
            <Skeleton className="custom-skeleton" width="96%" height="0.85rem" />
            <Skeleton className="custom-skeleton" width="88%" height="0.85rem" />
            <Skeleton className="custom-skeleton" width="70%" height="0.85rem" />
          </div>

          <div className="skeleton-bubble-footer">
            <Skeleton className="custom-skeleton" width="5rem" height="0.7rem" />
          </div>
        </div>
      </div>
    )
  }

  function SentMessageSkeleton() {
    return (
      <div className="message-row sent" aria-hidden="true">
        <div className="skeleton-bubble">
          <div className="skeleton-bubble-body">
            <Skeleton width="92%" height="0.85rem" />
            <Skeleton width="78%" height="0.85rem" />
          </div>

          <div className="skeleton-bubble-footer">
            <Skeleton width="4.5rem" height="0.7rem" />
          </div>
        </div>
      </div>
    )
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp)
    const today = new Date()
    const yesterday = new Date(today)

    yesterday.setDate(today.getDate() - 1)

    const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear()

    if (isToday) {
      return 'Today'
    }

    if (isYesterday) {
      return 'Yesterday'
    }

    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const groupedMessages = React.useMemo(() => {
    const sections = []
    const indexByLabel = Object.create(null)

    return chats.reduce((acc, m) => {
      const label = formatDate(m.timestamp)

      let idx = indexByLabel[label]

      if (idx === undefined) {
        idx = acc.length
        indexByLabel[label] = idx
        acc.push([label, []])
      }

      acc[idx][1].push(m)

      return acc
    }, sections)
  }, [chats])

  const onDragStartCb = React.useCallback((e, idx) => handleDragStart(e, idx), [handleDragStart])
  const onDropCb = React.useCallback((e, idx) => handleDrop(e, idx), [handleDrop])
  const onClickCb = React.useCallback((g) => handleCommunityClickAction(g), [handleCommunityClickAction])

  const handleDeleteForMe = async (msgObj) => {
    await supabase.rpc('delete_message_for_me', { message_id: msgObj?.id, user_id: userDetails?.id })
    // // setChats((prev) => prev.map((msg) => (msg.id === msgObj?.id ? { ...msg, content: 'This message was deleted.' } : msg))) // approach to show deleted message text
    setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
  }

  const handleDeleteForEveryone = async (msgObj) => {
    try {
      await supabase.rpc('delete_message_for_all', { message_id: msgObj?.id, user_id: userDetails?.id })
      // setChats((prev) => prev.map((msg) => (msg.id === msgObj?.id ? { ...msg, content: 'This message was deleted.' } : msg))) // approach to show deleted message text
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message for me:', error)
    }
  }

  const handleDeleteMessageByAdmin = async (msgObj) => {
    try {
      await supabase.rpc('remove_message', { message_id: msgObj?.id, bot_user_id: userDetails?.id })
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleDeleteAllMessageByAdmin = async (msgObj) => {
    try {
      await supabase.rpc('remove_all_user_messages', { target_userid: msgObj?.user_info?.userid, community_id: activeId, bot_user_id: userDetails?.id })
      setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleBlockUserByAdmin = async (msgObj) => {
    try {
      await supabase.rpc('block_user_from_community', { target_userid: msgObj?.user_info?.userid, community_id: activeId, bot_user_id: userDetails?.id, reason: 'Blocked by Admin' })
      // setChats((prev) => prev.filter((msg) => msg.id !== msgObj?.id))
    } catch (error) {
      console.log('Error deleting message by Admin:', error)
    }
  }

  const handleReportAbuse = async (msgObj) => {
    if (!selectedReportReason) return

    setIsReporting(true)

    try {
      await supabase.rpc('report_abuse', {
        p_reporter_userid: userDetails?.id,
        p_reported_userid: msgObj?.user_info?.userid,
        p_community_id: activeId,
        p_report_reason_id: selectedReportReason,
        p_message_id: msgObj?.id
      })

      setChats((prev) =>
        prev.map((msg) => {
          if (msg.id !== msgObj?.id) return msg

          const currentCount = Number.isFinite(msg?.abuse_flag_count) ? msg.abuse_flag_count : 0

          return {
            ...msg,
            abuse_flag_count: currentCount + 1,
            is_reported_by_me: true
          }
        })
      )
    } catch (error) {
      console.log('Error reporting abuse:', error)
    } finally {
      setIsReporting(false)
    }
  }
  const handleUndoReportAbuse = async (msgObj) => {
    try {
      await supabase.rpc('undo_report_abuse', {
        p_reporter_userid: userDetails?.id,
        p_reported_userid: msgObj?.user_info?.userid,
        p_community_id: activeId,
        p_message_id: msgObj?.id
      })

      setChats((prev) =>
        prev.map((msg) => {
          if (msg.id !== msgObj?.id) return msg

          const currentCount = Number.isFinite(msg?.abuse_flag_count) ? msg.abuse_flag_count : 0

          return {
            ...msg,
            abuse_flag_count: currentCount - 1,
            is_reported_by_me: false
          }
        })
      )
    } catch (error) {
      console.log('Error reporting abuse:', error)
    }
  }

  const openForwardModal = (msg) => {
    if (!msg) return
    setMessageToForward(msg)
    setForwardModalVisible(true)
    setForwardSearchTerm('')
  }

  return (
    <>
      {!userDetails || userDetails?.isCoffeeCommunityAvailable ? (
        <div className="coffee-communities">
          {/* Left: community list */}
          <aside className="community-sidebar">
            <div className="component-label">{t('COFFEE_COMMUNITIES')}</div>
            <div className="communities-label">
              <div className="community-search-input-div">
                <InputText value={searchCommunityTerm} onChange={(e) => handleCommunitySearch(e.target.value)} placeholder="Search Communities" className="community-search-input" />
                <button type="button" className="search-btn" aria-controls="search-input" onClick={handleCommunitySearch}>
                  <i className="pi pi-search" data-testid="web-search-icon" />
                </button>
              </div>
              {isCommunitiesLoading ? (
                <>
                  {Array(8)
                    .fill(null)
                    .map((_, index) => (
                      <CommunitiesSkeleton key={index} />
                    ))}
                </>
              ) : (
                <>
                  <div className={`community-items-container ${!userDetails ? 'guest-community-items-container' : ''}`}>{filteredGroupList?.length > 0 ? filteredGroupList.map((groupData, index) => <CommunityRow key={groupData.id} groupData={groupData} index={index} activeId={activeId} draggable={true} onDragStart={onDragStartCb} onDrop={onDropCb} onClick={onClickCb} />) : <div className="no-communities-message">No communities found</div>}</div>
                </>
              )}
            </div>
          </aside>
          {/* Right: chat area */}
          <section className={`chat-panel ${userDetails?.id ? '' : 'guest-user'}`}>
            <header className="chat-header">
              <div className="chat-header-container">
                {isCommunitiesLoading ? (
                  <div className="skeleton-container">
                    <div>
                      <Skeleton className="custom-skelton" shape="circle" size="2.25rem"></Skeleton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', gap: '0.25rem', alignItems: 'center' }}>
                      <Skeleton className="custom-skelton" width="10rem" height="2rem"></Skeleton>
                    </div>
                  </div>
                ) : (
                  <div className="active-community-details">
                    {activeCommunity?.isUrlApproval ? <i className="pi pi-shield url-approval-icon" aria-hidden="true" /> : <img alt="active-community-logo" src={activeCommunity?.community_url || 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'} />}
                    <div className="chat-heading">{activeCommunity?.name}</div>
                  </div>
                )}
                {/* commented for the future reference */}
                {/* <div className="search-div"> */}
                {/* <i className="pi pi-search" onClick={() => handleInChatSearch()} data-testid="web-search-icon" /> */}
                {/* <SearchBar onSearch={(value) => console.log('Search:', value)} /> */}
                {/* </div> */}
                {userDetails && !activeCommunity?.isCreateOwn && !activeCommunity?.isUrlApproval && <CommunitySubscriptionTypes subTypes={activeCommunity?.subscription_details} />}
              </div>
              <div className="action-container">
                {isAdminUser && userDetails && <div className="bot-user-title">{t('ADMIN')}</div>}
                <img alt="invite-icon" src={theme === 'light' ? 'https://coffeeweb.s3.ap-south-1.amazonaws.com/invite-icon-dark.png' : 'https://coffeeweb.s3.ap-south-1.amazonaws.com/invite-icon-light.png'} className="invite-icon" onClick={invite} />
              </div>
            </header>

            {/* Commented for Enhancement in future */}
            {/* <div className="skeleton-messages">
          {isChatLoading && (
            <>
              <div className="skeleton-bubble left">
                <ReceivedMessageSkeleton />
              </div>
              <div className="skeleton-bubble right">
                <SentMessageSkeleton />
              </div>
              <div className="skeleton-bubble left">
                <ReceivedMessageSkeleton />
              </div>
              <div className="skeleton-bubble right">
                <SentMessageSkeleton />
              </div>
            </>
          )}
        </div> */}

            {/* ========== URL Approval View / Chat View Switch =============== */}

            {renderMainContent()}
          </section>
          <DialogUIModal
            customClassName="confirmation-modal-coffee-communities"
            title="Blocked"
            showModal={showBlockedModal}
            bodyContent={() => <div>You have been blocked from this community and cannot send messages.</div>}
            footerContent={() => (
              <div className="confirmation-modal-buttons">
                {' '}
                <Button label="OK" className="confirmation-yes-button" onClick={() => setShowBlockedModal(false)} />{' '}
              </div>
            )}
            contentWidth="400px"
            handleClose={() => setShowBlockedModal(false)}
          />
          <DialogUIModal
            title={viewer?.name || 'View Attachment'}
            showModal={viewer.open}
            handleClose={closeViewer}
            bodyContent={viewerModalContent}
            size={isFullscreen ? undefined : 'lg'}
            contentWidth={isFullscreen ? '100%' : '90%'}
            contentHeight={isFullscreen ? '100vh' : '80vh'}
            customClassName={`attachment-viewer-modal ${isFullscreen ? 'fullscreen-mode' : ''}`}
            headerActions={
              <button className="fullscreen-toggle-btn" onClick={() => setIsFullscreen(!isFullscreen)} aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}>
                {isFullscreen ? <img className="window-minimize-icon" src={WindowMinimizeIcon} alt="WindowMinimizeIcon" /> : <img className="window-maximize-icon" src={WindowMaximizeIcon} alt="WindowMinimizeIcon" />}
              </button>
            }
          />
          <DialogUIModal customClassName="confirmation-modal-coffee-communities" title={modalTitle} showModal={confirmationModal} bodyContent={confirmationModalContent} footerContent={footerContent} contentWidth={modalAction === 'edit' || modalAction === 'reportAbuse' ? '36%' : '450px'} handleClose={() => setConfirmationModal(false)} />
          <DialogUIModal title={t('SHARE_MODAL')} showModal={isModalVisible} handleClose={() => setIsModalVisible(false)} bodyContent={shareListModalContent} shareNews={true} titlePosition="center" testId="share-news-feed-dialog-modal" customClassName="community-share-modal" />

          <ForwardMessageModal setSelectedCommunitiesForForward={setSelectedCommunitiesForForward} selectedCommunitiesForForward={selectedCommunitiesForForward} filteredGroupList={filteredGroupList} setForwardSearchTerm={setForwardSearchTerm} forwardSearchTerm={forwardSearchTerm} handleForwardToCommunity={handleForwardToCommunity} isForwarding={isForwarding} setForwardModalVisible={setForwardModalVisible} forwardModalVisible={forwardModalVisible} setMessageToForward={setMessageToForward} messageToForward={messageToForward} isAdminUser={isAdminUser} />
        </div>
      ) : (
        <ComingSoonPopUp />
      )}
    </>
  )
}

export default CoffeeCommunities
